import { ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  Validators,
  FormControl,
  AbstractControlOptions,
  AbstractControl,
  FormGroup,
} from '@angular/forms';
import { NospaceValidator } from 'src/app/core/validators/nospace-validator';
import { MustMatch } from 'src/app/core/validators/password-validator';
import { OutsideClickErrorStateMatcher } from 'src/app/core/validators/outclick-validators';
import { CommonHelperService } from 'src/app/core/utilities/common-helper/common-helper.service';
import { UserFacadeService } from 'src/app/facades/user/user-facade.service';
import { UserOnboarding } from 'src/app/core/models/user/user-onboarding.model';
import { AuthFacadeService } from 'src/app/facades/auth/auth-facade.service';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
import { ClientFacadeService } from 'src/app/facades/client/client-facade.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { LocationFacadesService } from 'src/app/facades/location/location-facades.service';
import { Observable, Subscription, map, of, startWith } from 'rxjs';
import { StripeService, StripeCardComponent } from 'ngx-stripe';
import {
  StripeCardElementChangeEvent,
  StripeCardElementOptions,
  StripeElementsOptions,
} from '@stripe/stripe-js';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionFacadeService } from 'src/app/facades/subscription/subscription-facade.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { UserFeedbackState } from 'src/app/core/utilities/user-feedback-state/user-feedback-state';
import { EncryptDecrypt } from 'src/app/core/store/icons/encrypt-decrypt';
import { FeedbackSnackbarService } from 'src/app/core/utilities/feedback-snackbar/feedback-snackbar.service';
import { HttpErrorResponse } from '@angular/common/http';
import { SharedService } from 'src/app/core/services/shared/shared.service';
import { StepperSelectionEvent } from '@angular/cdk/stepper/stepper';
@Component({
  selector: 'app-client-onboard',
  templateUrl: './client-onboard.component.html',
  styleUrls: ['./client-onboard.component.scss'],
})
export class ClientOnboardComponent implements OnInit, OnDestroy {
  @ViewChild('stepper', { static: false }) stepper!: MatStepper;
  @ViewChild(StripeCardComponent) card: StripeCardComponent;
  @ViewChild('stripeCardHost') stripeCardHost: StripeCardComponent;
  cardOptions: StripeCardElementOptions;
  elementsOptions: StripeElementsOptions = {
    locale: 'en',
  };
  stateFilterCtrl = new FormControl('');
  countryFilterCtrl = new FormControl('');
  locationFilterCtrl = new FormControl('');
  timeZoneFilterCtrl = new FormControl('');
  userFeedback = new UserFeedbackState();
  emailFormGroup: FormGroup;
  personalFormGroup: FormGroup;
  errorMsg: string;
  readonly businessLoginUrl = environment.partUrl;
  showExistingAccountLoginMessage = false;
  stylistEmailExistingAccount = false;
  customer: boolean = false;
  businessFormGroup: FormGroup;
  locationFormGroup: FormGroup;
  stylistFormGroup: FormGroup;
  stripeFormGroup: FormGroup;
  emailError: boolean = false;
  showNewPassword!: boolean;
  showConfirmPassword!: boolean;
  darkMode: boolean = false;
  matcher = new OutsideClickErrorStateMatcher();
  formSubmissionInfo: { email: any; personal: any; business: any; location: any; stylist: any };
  signupAuthInfo: { authId: any; signInMethod: any };
  phoneInputComponent: NgxMatIntlTelInputComponent;
  filteredCountry: Observable<any[]>;
  filteredLocation: Observable<any[]>;
  filteredState: Observable<any[]>;
  filteredTimeZone: Observable<any[]>;
  country: string;
  planId: any;
  freePlan: any;
  trialPeriod: any;
  payment: boolean;
  token: string;
  paymentMethod: any;
  pricingId: string;
  clientId: any;
  userId: any;
  paySuccess: boolean;
  cardErrors: string | null = null;
  isSubmitted: boolean = false;
  isProcessing: boolean = false;
  /** Initial country/plan bootstrap only — must not hide the form during Pay/submit. */
  isPageLoading = true;
  private subscriptionChargeConfirmed = false;
  /** Set when Pay is clicked with a complete Stripe card (used after long onboarding API chain). */
  private cardValidatedAtPay = false;
  /** True from Pay click until payment finishes — keeps Stripe element in DOM. */
  paymentInProgress = false;
  private stylistPostPaymentHandled = false;
  stopRegistration: boolean = false;
  hidePasswords: boolean = false;
  passwordMessage: string = '';
  countryList: any[] = [];
  stateList: any[] = [];
  onBoardingUserDetails: UserOnboarding;
  subscriptionDetail: any;
  subFreeId: any;
  authId: any;
  emptyProvince: boolean = false;
  subType: any;
  offerAmount: any;
  originalPrice: any;
  signInMethod: string;
  promoCodeValue: any;
  promoPriceView: boolean = false;
  hideOffer = false;
  promoMessage: string;
  promoError: string;
  promoValidation: any;
  countryId: any;
  payAmount: number;
  inputValue: any = 1;
  planName: any;
  countryName: any;
  locations: any;
  emailErrorMessage: string;
  locationError: boolean = false;
  timeZoneList: any;
  locationCount: any;
  isLocationCountReached: boolean;
  cardComplete: boolean = false;
  nextClickList: any[] = [];
  locationNextClick: boolean = false;
  stylistNextClick: boolean = false;
  nextClickStylistList: any[] = []
  countryCode: string = 'us';
  nextClick: boolean = false;
  existingAmount: any;
  keyCodeValue: string;
  exitingPricingId: any;
  code: string;
  isLoading: boolean = false;
  paymentErrorMessage: string | null = null;
  /** Account/locations/providers saved but card/subscription payment did not finish. */
  paymentRecoveryMode = false;
  paymentFailureReason = '';
  private onboardingRegistrationComplete = false;
  private isFinalClick: boolean = false;
  /** Set after successful CreateOnBoardingClient in this session — avoids duplicate client API calls on retry. */
  private clientRecordCreated = false;
  private locationsPersisted = false;
  private stylistsPersisted = false;
  platFormClass: string;
  platFormImageClass: string;
  platFormPayClass: string;
  addValidate: boolean;
  promoCodeRemove: any;
  keyCode: any;
  @ViewChild('phoneInput', { static: false }) set phoneInput(
    content: NgxMatIntlTelInputComponent
  ) {
    if (content) {
      this.phoneInputComponent = content;
      this.applyPhoneSelectedCountry(this.resolvePlanCountryIso2());
    }
  }
  currencyToCountryMap: { [key: string]: string } = {
    AED: 'AE', AFN: 'AF', ALL: 'AL', AMD: 'AM', ANG: 'NL', AOA: 'AO',
    ARS: 'AR', AUD: 'AU', AWG: 'AW', AZN: 'AZ', BAM: 'BA', BBD: 'BB',
    BDT: 'BD', BGN: 'BG', BHD: 'BH', BIF: 'BI', BMD: 'BM', BND: 'BN',
    BOB: 'BO', BRL: 'BR', BSD: 'BS', BTN: 'BT', BWP: 'BW', BYN: 'BY',
    BZD: 'BZ', CAD: 'CA', CDF: 'CD', CHF: 'CH', CLP: 'CL', CNY: 'CN',
    COP: 'CO', CRC: 'CR', CUP: 'CU', CVE: 'CV', CZK: 'CZ', DJF: 'DJ',
    DKK: 'DK', DOP: 'DO', DZD: 'DZ', EGP: 'EG', ERN: 'ER', ETB: 'ET',
    EUR: 'EU', FJD: 'FJ', FKP: 'FK', GBP: 'GB', GEL: 'GE', GHS: 'GH',
    GIP: 'GI', GMD: 'GM', GNF: 'GN', GTQ: 'GT', GYD: 'GY', HKD: 'HK',
    HNL: 'HN', HRK: 'HR', HTG: 'HT', HUF: 'HU', IDR: 'ID', ILS: 'IL',
    INR: 'IN', IQD: 'IQ', IRR: 'IR', ISK: 'IS', JMD: 'JM', JOD: 'JO',
    JPY: 'JP', KES: 'KE', KGS: 'KG', KHR: 'KH', KMF: 'KM', KRW: 'KR',
    KWD: 'KW', KYD: 'KY', KZT: 'KZ', LAK: 'LA', LBP: 'LB', LKR: 'LK',
    LRD: 'LR', LSL: 'LS', LYD: 'LY', MAD: 'MA', MDL: 'MD', MGA: 'MG',
    MKD: 'MK', MMK: 'MM', MNT: 'MN', MOP: 'MO', MRU: 'MR', MUR: 'MU',
    MVR: 'MV', MWK: 'MW', MXN: 'MX', MYR: 'MY', MZN: 'MZ', NAD: 'NA',
    NGN: 'NG', NIO: 'NI', NOK: 'NO', NPR: 'NP', NZD: 'NZ', OMR: 'OM',
    PAB: 'PA', PEN: 'PE', PGK: 'PG', PHP: 'PH', PKR: 'PK', PLN: 'PL',
    PYG: 'PY', QAR: 'QA', RON: 'RO', RSD: 'RS', RUB: 'RU', RWF: 'RW',
    SAR: 'SA', SBD: 'SB', SCR: 'SC', SDG: 'SD', SEK: 'SE', SGD: 'SG',
    SHP: 'SH', SLL: 'SL', SOS: 'SO', SRD: 'SR', SSP: 'SS', STD: 'ST',
    SYP: 'SY', SZL: 'SZ', THB: 'TH', TJS: 'TJ', TMT: 'TM', TND: 'TN',
    TOP: 'TO', TRY: 'TR', TTD: 'TT', TWD: 'TW', TZS: 'TZ', UAH: 'UA',
    UGX: 'UG', USD: 'US', UYU: 'UY', UZS: 'UZ', VES: 'VE', VND: 'VN',
    VUV: 'VU', WST: 'WS', XAF: 'CM', XCD: 'AG', XOF: 'SN', YER: 'YE',
    ZAR: 'ZA', ZMW: 'ZM', ZWL: 'ZW'
  };
  selectedCountry: any = { iso2: 'us', dialCode: '+1' };
  amount: any;
  currencySymbol: any;
  totalPrice: any;
  locationList: any[] = [];
  stylistList: any[] = [];
  editIndex: number | null = null;
  editStylistIndex: number | null = null;
  zipCodeTimeout: any;
  // FIX 1: Zip code debouncing, caching & cancellation
  private zipCodeTimeouts: { business?: any; location?: any } = {};
  private zipCodeSubscriptions: { business?: Subscription; location?: Subscription } = {};
  private lastValidatedZip: { business?: string; location?: string } = {};

  // FIX 2: Stylist email debouncing, caching & cancellation
  private stylistEmailDebounceTimer: any;
  private emailLookupSubscription?: Subscription;
  private emailLookupCache = new Map<string, UserOnboarding>();
  private lastCheckedStylistEmail: string = '';

  // FIX 3: Email in FB & DB debouncing, caching & cancellation
  private clientEmailValidationResult: any = null;
  private emailInFBandDBCache = new Map<string, any>();
  private clientEmailDebounceTimer: any;
  private clientEmailSubscription?: Subscription;
  private lastValidatedClientEmail: string = '';

  stylistEdit: boolean = false;
  locationEdit: boolean = false;
  preferredCountryList: string[] = [];
  emptyProvinceTimeZone: boolean = false;
  timeZoneUnresolved = false;
  private originalEditTimeZone = '';
  private timeZoneLoadSub?: Subscription;
  private isRemovingLocation = false;
  private isRemovingStylist = false;
  emptyProvinceState: boolean = false;
  emptyProvinceLocation: boolean = false;
  NextButtonDisable: boolean = false
  blockBackNav = true;
  locationValid: boolean;
  stylistValid: boolean;
  /* Completed-step navigation (see ONBOARDING_FULL_ANALYSIS.md §3):
     the stepper previously had no record of completion, so revisiting
     a finished step depended on its form staying valid forever — but
     steps 3/4 empty their forms into lists by design, and async
     validators (zip, email) can retro-invalidate steps 0/2. These
     flags are that missing record. Index 5 = optional Payment step. */
  completedSteps: boolean[] = [false, false, false, false, false, false];
  furthestStepIndex = 0;
  currentStepIndex = 0;
  private readonly DRAFT_STORAGE_KEY = 'vm_onboarding_draft';
  private isRestoringDraft = false;

  constructor(
    private formBuilder: FormBuilder,
    private commonHelper: CommonHelperService,
    private userFacadeService: UserFacadeService,
    private authServiceFacade: AuthFacadeService,
    private clientFacade: ClientFacadeService,
    private locationFacadeService: LocationFacadesService,
    private stripeService: StripeService,
    private activatedRouter: ActivatedRoute,
    private snackBar: FeedbackSnackbarService,
    private subscriptionFacadeService: SubscriptionFacadeService,
    private errorSnackBar: MatSnackBar,
    private encryptDecrypt: EncryptDecrypt,
    private cdr: ChangeDetectorRef,
    private sharedService: SharedService,
    private ngZone: NgZone,
  ) {
    this.planId = this.activatedRouter.snapshot.queryParamMap.get('id');
    this.subFreeId = Number(
      this.activatedRouter.snapshot.queryParamMap.get('sub')
    );
    this.subType = this.activatedRouter.snapshot.queryParamMap.get('subType');
    this.currencySymbol = this.activatedRouter.snapshot.queryParamMap.get('currency');
    this.countryId = this.activatedRouter.snapshot.queryParamMap.get('countryId');
    const key = this.activatedRouter.snapshot.queryParamMap.get('keyCode');
    this.keyCodeValue = key !== null && key !== 'null' ? key : '';
    this.getPlanDetailById(this.planId);
    // this.decryptData(this.planDetail);

    // if (this.freePlan == false) {
    //   this.payment = true;
    // }
    this.darkMode = this.commonHelper.isDarkEnabled();
    if (this.darkMode) {
      this.cardOptions = {
        style: {
          base: {
            iconColor: '#E8EAED',
            color: '#FFFFFF',
            fontWeight: '400',
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSize: '15px',
            lineHeight: '22px',
            '::placeholder': {
              color: '#9AA0A6',
            },
          },
          invalid: {
            color: '#f87171',
            iconColor: '#f87171',
          },
        },
        hidePostalCode: true,
      };
    } else {
      this.cardOptions = {
        style: {
          base: {
            iconColor: '#6B7280',
            color: '#111827',
            fontWeight: '400',
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSize: '15px',
            lineHeight: '22px',
            '::placeholder': {
              color: '#9CA3AF',
            },
          },
          invalid: {
            color: '#DC2626',
            iconColor: '#DC2626',
          },
        },
        hidePostalCode: true,
      };
    }
    this.emailFormGroup = this.formBuilder.group({
      emailCtrl: new FormControl('', [
        Validators.required,
        Validators.email,
        NospaceValidator.blockSpace,
      ]),
    });
    this.personalFormGroup = this.formBuilder.group(
      {
        firstName: new FormControl('', [
          Validators.required,
          NospaceValidator.blockSpace,
        ]),
        lastName: new FormControl('', [
          Validators.required,
          NospaceValidator.blockSpace,
        ]),
        mobNumber: new FormControl('', [Validators.required]),
        password: new FormControl('', [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(
            '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'
          ),
        ]),
        confirmPassword: new FormControl('', [Validators.required]),
      },
      {
        validator: MustMatch('password', 'confirmPassword'),
      }
    );
    this.businessFormGroup = this.formBuilder.group({
      busiName: new FormControl('', Validators.required),
      //"locName": new FormControl('', Validators.required),
      address1: new FormControl('', Validators.required),
      address2: new FormControl(''),
      city: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      zipCode: [{ value: '', disabled: true }, [Validators.required]]
    });

    this.locationFormGroup = this.formBuilder.group({
      locationName: new FormControl('', Validators.required),
      address1: new FormControl('', Validators.required),
      address2: new FormControl(''),
      city: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      timeZone: new FormControl('', Validators.required),
      zipCode: [{ value: '', disabled: true }, [Validators.required]]
    });
    this.stylistFormGroup = this.formBuilder.group({
      location: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.pattern('^[^@]+@([-\\w]+\\.)+[A-Za-z]{2,4}$')]),
    });

    this.stripeFormGroup = this.formBuilder.group({
      promoCode: new FormControl(''),
      cardNumber: new FormControl('', Validators.required),
    });
  }

  // decryptData(data) {
  //   this.subscriptionDetail = this.encryptDecrypt.decryptData(data);
  //     this.planId = this.subscriptionDetail.planId;
  //     this.subFrequency = localStorage.getItem('subscriptionFrequency');
  //     this.freePlan = this.subscriptionDetail.freePlan;
  //     this.trialPeriod = this.subscriptionDetail.trialPeriod;
  //     this.pricingId = this.subscriptionDetail.pricingId;
  //     this.subFreeId=this.subscriptionDetail.subFreeId
  //     if (this.freePlan == false && this.trialPeriod == false) {
  //       this.payment = true;
  //     } else if (this.freePlan == true || this.trialPeriod == true) {
  //       this.payment = false;
  //     }
  // }

  ngOnInit(): void {
    this.isPageLoading = true;
    this.fetchCountryList();
    this.countryFilterCtrl.valueChanges.subscribe((searchValue) => {
      this.filteredCountry
        .pipe(map((items) => items.map((item) => item.countryName)))
        .subscribe((filteredCountries) => {
          if (filteredCountries[0] == undefined) {
            this.emptyProvince = true;
          } else {
            this.emptyProvince = false;
          }
        });
    });
    this.stateFilterCtrl.valueChanges.subscribe((searchValue) => {
      this.filteredState
        .pipe(map((items) => items.map((item) => item.state)))
        .subscribe((filteredStates) => {
          if (filteredStates[0] == undefined) {
            this.emptyProvinceState = true;
          } else {
            this.emptyProvinceState = false;
          }
        });
    });
    this.locationFilterCtrl.valueChanges.subscribe((searchValue) => {
      this.updateFilteredLocations(searchValue);
    });
    this.timeZoneFilterCtrl.valueChanges.subscribe((searchValue) => {
      this.filteredTimeZone
        .pipe(map((items) => items.map((item) => item.timeZone)))
        .subscribe((filteredTimeZone) => {
          if (filteredTimeZone[0] == undefined) {
            this.emptyProvinceTimeZone = true;
          } else {
            this.emptyProvinceTimeZone = false;
          }
        });
    });
    this.setPlatformClass();
    this.clearDraftStorage();
    this.initializePlanCountryFromQuery();
    this.syncPhoneCountryFromPlan();
    this.updateFilteredLocations();

    this.emailFormGroup.valueChanges.subscribe(() => this.saveDraftToStorage());
    this.personalFormGroup.valueChanges.subscribe(() => this.saveDraftToStorage());
    this.businessFormGroup.valueChanges.subscribe(() => this.saveDraftToStorage());
    this.locationFormGroup.valueChanges.subscribe(() => this.saveDraftToStorage());
    this.stylistFormGroup.valueChanges.subscribe(() => this.saveDraftToStorage());
  }

  ngOnDestroy(): void {
    if (this.clientEmailDebounceTimer) {
      clearTimeout(this.clientEmailDebounceTimer);
    }
    if (this.clientEmailSubscription) {
      this.clientEmailSubscription.unsubscribe();
    }
    if (this.stylistEmailDebounceTimer) {
      clearTimeout(this.stylistEmailDebounceTimer);
    }
    if (this.emailLookupSubscription) {
      this.emailLookupSubscription.unsubscribe();
    }
    if (this.zipCodeTimeouts.business) {
      clearTimeout(this.zipCodeTimeouts.business);
    }
    if (this.zipCodeTimeouts.location) {
      clearTimeout(this.zipCodeTimeouts.location);
    }
    if (this.zipCodeSubscriptions.business) {
      this.zipCodeSubscriptions.business.unsubscribe();
    }
    if (this.zipCodeSubscriptions.location) {
      this.zipCodeSubscriptions.location.unsubscribe();
    }
    if (this.timeZoneLoadSub) {
      this.timeZoneLoadSub.unsubscribe();
    }
    this.clearDraftStorage();
  }

  private setPlatformClass() {
    // Set platformClass only if screen width is larger than 768px (tablet and desktop)
    if (window.innerWidth > 768) {
      const userAgent = window.navigator.userAgent.toLowerCase();
      this.platFormClass = userAgent.includes("mac")
        ? "mat-stepper-vertical-mac"
        : "mat-stepper-vertical";
      this.platFormImageClass = userAgent.includes("mac")
        ? "login-image-part-mac"
        : "login-image-part";
      this.platFormPayClass = userAgent.includes("mac")
        ? "mat-stepper-vertical-mac-pay"
        : "mat-stepper-vertical";
    } else {
      this.platFormClass = "";
      this.platFormImageClass = "";
    }
  }

  get password(): AbstractControl {
    return this.personalFormGroup.get('password');
  }

  get confirmPassword(): AbstractControl {
    return this.personalFormGroup.get('confirmPassword');
  }
  get emailfval() {
    return this.emailFormGroup.controls;
  }

  get perfval() {
    return this.personalFormGroup.controls;
  }

  get busifval() {
    return this.businessFormGroup.controls;
  }

  get locationFVal() {
    return this.locationFormGroup.controls;
  }

  get stylistFVal() {
    return this.stylistFormGroup.controls;
  }

  get stripefval() {
    return this.stripeFormGroup.controls;
  }

  emailEvent(event: any): void {
    const emailControl = this.emailFormGroup?.get('emailCtrl');
    const email = (emailControl?.value ?? event?.target?.value ?? '').toString().trim().toLowerCase();

    // Cancel in-flight request if input changes
    if (this.clientEmailSubscription) {
      this.clientEmailSubscription.unsubscribe();
      this.clientEmailSubscription = undefined;
    }

    // Reset debounce timer
    if (this.clientEmailDebounceTimer) {
      clearTimeout(this.clientEmailDebounceTimer);
      this.clientEmailDebounceTimer = undefined;
    }

    // Clear stale backend errors when the user modifies the email
    if (email !== this.lastValidatedClientEmail) {
      this.emailError = false;
      this.showExistingAccountLoginMessage = false;
      this.errorMsg = '';
      this.stopRegistration = false;
      if (emailControl?.errors?.['incorrect']) {
        const updatedErrors = { ...emailControl.errors };
        delete updatedErrors['incorrect'];
        emailControl.setErrors(Object.keys(updatedErrors).length ? updatedErrors : null);
      }
    }

    if (!email) {
      this.lastValidatedClientEmail = '';
      return;
    }

    // Do not repeatedly validate the same unchanged email
    if (email === this.lastValidatedClientEmail) {
      return;
    }

    // Call API only when email format is valid and control has no format/space errors
    if (
      !emailControl ||
      emailControl.invalid ||
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    ) {
      this.lastValidatedClientEmail = '';
      return;
    }

    this.clientEmailDebounceTimer = setTimeout(() => {
      this.checkEmailinFBandDB(email).catch(() => { });
    }, 500);
  }

  onEmailNext(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    const emailControl = this.emailFormGroup?.get('emailCtrl');
    emailControl?.markAsTouched();
    const email = (emailControl?.value || '').toString().trim().toLowerCase();

    if (
      !email ||
      this.emailFormGroup.invalid ||
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ||
      this.emailError
    ) {
      return;
    }

    if (this.clientEmailDebounceTimer) {
      clearTimeout(this.clientEmailDebounceTimer);
      this.clientEmailDebounceTimer = undefined;
    }

    // If already validated for this exact unchanged email and no error, advance directly
    if (email === this.lastValidatedClientEmail && !this.emailError && !this.emailFormGroup.invalid) {
      this.completedSteps[0] = true;
      this.saveDraftToStorage();
      if (this.stepper) {
        this.stepper.selectedIndex = 1;
      }
      return;
    }

    this.checkEmailinFBandDB(email)
      .then(() => {
        if (!this.emailError && !this.emailFormGroup.invalid) {
          this.completedSteps[0] = true;
          this.saveDraftToStorage();
          if (this.stepper) {
            this.stepper.selectedIndex = 1;
          }
        }
      })
      .catch(() => { });
  }

  createToken(): void {
    const stripeCard = this.getStripeCardComponent();
    if (!stripeCard?.element) {
      this.handlePaymentFailure('Please enter card details');
      return;
    }
    this.card = stripeCard;
    const firstName = this.personalFormGroup.get('firstName').value;
    const lastName = this.personalFormGroup.get('lastName').value;
    const fullName = `${firstName} ${lastName}`;
    this.stripeService
      .createToken(this.card.element, {
        // Pass the card element and optional data
        name: fullName, // Get the cardholder's name from the form
      })
      .subscribe({
        next: (result) => {
          if (result.token) {
            // Use the generated token
            this.token = result.token.id;
            if (this.token) {
              this.createCard();
            }
            // Send this token to your server for payment processing
          } else if (result.error) {
            const msg =
              result.error.message ==
                'We are experiencing issues connecting to our payments provider. Please check your internet connection.'
                ? 'Your payment process was interrupted. Please try again.'
                : result.error.message;
            this.handlePaymentFailure(msg, result.error);
          } else {
            this.handlePaymentFailure('Could not process card. Please try again.');
          }
        },
        error: (err) => {
          this.handlePaymentFailure(
            !navigator.onLine
              ? 'Your payment process was interrupted. Please try again.'
              : 'An error occurred with Stripe. Please try again.',
            err
          );
        },
      });
  }

  createCard() {
    if (!this.token) {
      this.handlePaymentFailure('Could not process card. Please try again.');
      return;
    }
    const firstName = this.personalFormGroup.get('firstName').value;
    const lastName = this.personalFormGroup.get('lastName').value;
    const fullName = `${firstName} ${lastName}`;
    let data = {
      customerEmail: this.emailFormGroup.get('emailCtrl').value,
      customerName: fullName,
      cardToken: this.token,
      saveCard: false,
    };
    this.subscriptionFacadeService.createCard(data).subscribe({
      next: (response: any) => {
        this.paymentMethod = response;
        const cardMsg = this.normalizeTextResponse(response);
        if (cardMsg === 'Your card has insufficient funds.') {
          this.handlePaymentFailure('Your card has insufficient funds.', response);
        } else if (cardMsg === 'Your card was declined.') {
          this.handlePaymentFailure('Your card was declined.', response);
        } else if (cardMsg === 'Your card has expired.') {
          this.handlePaymentFailure('Your card has expired.', response);
        } else if (cardMsg === "Your card's security code is incorrect.") {
          this.handlePaymentFailure("Your card's security code is incorrect.", response);
        } else if (this.isLikelyPaymentErrorText(cardMsg)) {
          this.handlePaymentFailure(cardMsg, response);
        } else {
          this.createSubscription();
        }
      },
      error: (err) => {
        this.handlePaymentFailure(
          !navigator.onLine
            ? 'Your payment process was interrupted. Please try again.'
            : 'Something went wrong, Please try again.',
          err
        );
      },
    });
  }

  createSubscription() {
    try {
      if (!this.ensureFormSubmissionSnapshot()) {
        this.handlePaymentFailure('Please complete all steps before paying.');
        return;
      }
      if (!this.pricingId) {
        this.handlePaymentFailure(
          'Plan pricing is not loaded. Please refresh the page and try again.'
        );
        return;
      }
      const personal = this.formSubmissionInfo.personal;
      const quantity = Math.max(this.serviceProviderCount, 1);
      let data = {
        clientName: `${personal.firstName || ''}${personal.lastName || ''}`,
        paymentMethodId: this.countryId == 233 ? this.paymentMethod : '',
        email: this.emailFormGroup.get('emailCtrl').value,
        pricingId: this.pricingId,
        phoneNumber: this.countryId != 233 ? personal.mobNumber : '',
        countryId: Number(this.countryId),
        clientId: this.clientId ? Number(this.clientId) : 0,
        quantity,
        payAmount: this.payAmount,
        subscriptionFrequencyId: this.subFreeId,
        countryCurrencyCode: this.code,
        unUsedSubscriptionAmount: 0,
        isSelectAll: true,
        stylistIds: [0],
        walletAmountUsed: 0,
      };
      this.subscriptionFacadeService.createSubscription(data).subscribe({
        next: (response: any) => {
          this.ngZone.run(() => this.handleCreateSubscriptionResponse(response));
        },
        error: (err) => {
          this.ngZone.run(() => {
            this.handlePaymentFailure(
              !navigator.onLine
                ? 'Your payment process was interrupted. Please try again.'
                : 'Payment could not be completed.',
              err
            );
          });
        },
      });
    } catch {
      this.handlePaymentFailure('Something went wrong, Please try again.');
    }
  }

  private handleCreateSubscriptionResponse(response: any): void {
    if (Number(this.countryId) === 233) {
      const alreadyPaid =
        this.normalizeTextResponse(response).toLowerCase() ===
        'customer already has an active subscription with a paid invoice';
      if (alreadyPaid) {
        this.completeOnboardingSuccess();
        this.subscriptionSuccess(
          'Payment already completed. You can sign in to your account.'
        );
        return;
      }
      if (this.isSubscriptionSuccess(response)) {
        this.subscriptionChargeConfirmed = true;
        this.updateAutoRenewal();
        return;
      }
      this.handlePaymentFailure(
        this.resolvePaymentFailureMessage(
          'Payment could not be completed.',
          response
        ),
        response
      );
      return;
    }
    this.updateBillingAddress();
    this.launchRazorPayCheckout(response);
  }

  updateAutoRenewal() {
    let data = {
      customerEmail: this.emailFormGroup.get('emailCtrl').value,
      isAutoRenewal: false,
    };
    this.subscriptionFacadeService.updateAutoRenewal(data).subscribe({
      next: () => {
        this.ngZone.run(() => this.completeOnboardingSuccess());
      },
      error: (err) => {
        this.ngZone.run(() => {
          if (this.subscriptionChargeConfirmed) {
            this.completeOnboardingSuccess();
            this.subscriptionSuccess(
              'Payment completed. Auto-renewal preference could not be saved; you can sign in to your account.'
            );
          } else {
            this.handlePaymentFailure(
              !navigator.onLine
                ? 'Your payment process was interrupted. Please try again.'
                : 'Something went wrong, Please try again.',
              err
            );
          }
        });
      },
    });
  }

  submitOnboardingForm() {
    if (this.userFeedback.loading || this.isPageLoading) {
      return; // Prevent duplicate submissions on double-click
    }
    this.stylistPostPaymentHandled = false;
    this.userFeedback.startLoading();
    if (this.payment === true) {
      this.paymentInProgress = true;
    }

    if (this.payment) {
      if (!this.cardComplete && this.countryId == 233) {
        this.cardErrors = 'Please enter card details';
        this.userFeedback.stopLoading();
        this.cardValidatedAtPay = false;
        return;
      }
      if (this.countryId == 233) {
        this.cardValidatedAtPay = !!this.cardComplete;
      }
    }
    let stylistFormValid = this.stylistFormGroup.valid;
    if (this.isStylistFormEmpty()) {
      stylistFormValid = true;
    } else {
      stylistFormValid = this.stylistFormGroup.valid;
    }
    if (
      this.emailFormGroup.valid &&
      this.personalFormGroup.valid &&
      this.businessFormGroup.valid &&
      // Locations may exist only in locationList/nextClickList (the
      // form is emptied by Add by design) — count that as satisfied,
      // exactly as the stylist check above already does. Typed-form
      // validation itself is unchanged.
      (this.locationFormGroup.valid || this.locationList.length > 0 || this.nextClickList.length > 0) &&
      stylistFormValid
    ) {
      const formValue = {
        email: this.emailFormGroup.value,
        personal: this.personalFormGroup.value,
        business: this.businessFormGroup.value,
        location: this.locationFormGroup.value,
        stylist: this.stylistFormGroup.value,
      };
      this.formSubmissionInfo = formValue;

      // Ensure current stylist is in nextClickStylistList if valid and not empty
      if (formValue.stylist?.email && formValue.stylist?.location) {
        const curEmail = formValue.stylist.email?.trim().toLowerCase();
        const alreadyPresent = this.nextClickStylistList.some(s => s.email?.trim().toLowerCase() === curEmail) ||
          this.stylistList.some(s => s.email?.trim().toLowerCase() === curEmail);
        if (!alreadyPresent) {
          this.nextClickStylistList.push(formValue.stylist);
        }
      }

      const clientEmail = (this.formSubmissionInfo.email?.emailCtrl || '').trim().toLowerCase();
      const providerEmail = (
        this.stylistFormGroup.get('email')?.value ||
        this.stylistList?.[0]?.email ||
        this.nextClickStylistList?.[0]?.email ||
        ''
      ).trim().toLowerCase();

      const proceedWithSubmission = () => {
        try {
          this.isFinalClick = true;

          // CASE 1: Existing Client / Business User (userTypeId = 4 or userType = 'Client')
          if (
            this.onBoardingUserDetails?.userTypeId === 4 ||
            this.onBoardingUserDetails?.userType === 'Client'
          ) {
            this.userFeedback.stopLoading();
            this.isProcessing = false;
            this.setExistingClientLoginError();
            return;
          }

          // CASE 3 & New User: Customer (userTypeId = 5 or userType = 'Customer' or empty)
          if (
            this.onBoardingUserDetails?.userType === 'Customer' ||
            this.onBoardingUserDetails?.userTypeId === 5 ||
            this.onBoardingUserDetails?.userType === '' ||
            !this.onBoardingUserDetails?.userType
          ) {
            if (this.onBoardingUserDetails?.isFirebaseRegistered === false) {
              if (this.clientId !== 0 && this.clientId !== undefined) {
                this.getClientById(this.clientId);
              } else {
                // If authId is null, Firebase registration is genuinely missing -> sign up in Firebase
                if (this.onBoardingUserDetails?.authId == null) {
                  this.firebaseSignup();
                }
                // For user blocked after email verify and FB signup
                else if (
                  this.onBoardingUserDetails?.authId != null &&
                  this.onBoardingUserDetails?.emailVerified === true
                ) {
                  this.authId = this.onBoardingUserDetails.authId;
                  this.signInMethod = this.onBoardingUserDetails.signInMethod;
                  this.createOnBoardClient();
                }
                // For user blocked before email verify and FB signup
                else if (
                  this.onBoardingUserDetails?.authId != null &&
                  this.onBoardingUserDetails?.emailVerified === false
                ) {
                  this.verifyEmail(this.onBoardingUserDetails);
                } else {
                  this.userFeedback.stopLoading();
                  this.isProcessing = false;
                }
              }
            } else {
              this.createOnBoardClient();
            }
          } else if (
            this.onBoardingUserDetails?.userType === 'ServiceProvider' &&
            this.onBoardingUserDetails?.unPaidUser === true
          ) {
            this.updataOnboardClient();
          } else if (
            this.onBoardingUserDetails?.userType === 'ServiceProvider' &&
            this.onBoardingUserDetails?.userTypeId === 3
          ) {
            // Existing Service Provider being mapped: reuse identity, skip duplicate creation, continue
            if (this.onBoardingUserDetails?.authId) {
              this.authId = this.onBoardingUserDetails.authId;
              this.signInMethod = this.onBoardingUserDetails.signInMethod;
            }
            this.createOnBoardClient();
          } else {
            // Terminate cleanly for any unhandled branch
            this.userFeedback.stopLoading();
            this.isProcessing = false;
          }
        } catch (error) {
          this.userFeedback.stopLoading();
          this.isProcessing = false;
          this.subscriptionError('Something went wrong, Please try again.');
        }
      };

      // FIX 3: Compare client email and provider email
      const isSameEmail = !providerEmail || providerEmail === clientEmail;
      const hasValidClientResult = this.clientEmailValidationResult &&
        this.clientEmailValidationResult.email?.trim().toLowerCase() === clientEmail;

      if (isSameEmail) {
        // Scenario A: Same Email -> Reuse existing valid check result; do not call CheckEmailInFBandDB again!
        if (hasValidClientResult) {
          this.onBoardingUserDetails = this.clientEmailValidationResult;
          this.clientId = this.onBoardingUserDetails.clientId || 0;
          proceedWithSubmission();
        } else {
          this.checkEmailinFBandDB(clientEmail)
            .then(() => proceedWithSubmission())
            .catch(() => {
              /* error message + loader cleared in checkEmailinFBandDB */
            });
        }
      } else {
        // Scenario B: Different Email -> Validate provider email separately
        this.checkEmailinFBandDB(providerEmail)
          .then(() => proceedWithSubmission())
          .catch(() => {
            /* error message + loader cleared in checkEmailinFBandDB */
          });
      }
    } else {
      this.clearSubmissionLoadingState();
    }
  }
  limitInputLength(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.value.length > 15) {
      input.value = input.value.slice(0, 15);
    }
  }

  //Create entry in firebase
  firebaseSignup() {
    const email = this.formSubmissionInfo.email.emailCtrl;
    const pass = this.formSubmissionInfo.personal.password;
    if (!pass) {
      this.isFinalClick = false;
      this.isProcessing = false;
      this.userFeedback.stopLoading();
      this.subscriptionError('Please enter a password to complete registration.');
      return;
    }
    this.authServiceFacade
      .signUp(email, pass)
      .then((response: any) => {
        const authInfo = {
          authId: response.uid,
          signInMethod: response.providerData[0].providerId,
        };
        this.signupAuthInfo = authInfo;
        this.verifyEmail(authInfo);
      })
      .catch((error) => {
        // handle error here
        this.isFinalClick = false;
        this.isProcessing = false;
        this.stopRegistration = true;
        this.userFeedback.stopLoading();
        if (!navigator.onLine) {
          this.subscriptionError(
            'You are offline. Please check your internet connection.'
          );
        } else {
          // handle error.
          this.errorSocialMessage(error);
        }
      });
  }

  // Initialize total price on load
  initializeTotalPrice() {
    if (this.amount && !isNaN(this.amount)) {
      this.totalPrice = this.amount * 1;
    } else {
      this.totalPrice = 0;
    }
    let multiplier = 1;
    if (this.subType === 'yearly') {
      multiplier = 12;
    } else if (this.subType === 'quarterly') {
      multiplier = 3;
    }
    this.inputValue = 1;
    this.payAmount = this.totalPrice * multiplier;
  }

  // Handle input change and update totalPrice
  totalInput() {
    this.inputValue = this.nextClickStylistList.length === 0 ? this.stylistList.length : this.nextClickStylistList.length;
    let multiplier = 1;
    if (this.subType === 'yearly') {
      multiplier = 12;
    } else if (this.subType === 'quarterly') {
      multiplier = 3;
    }
    if (this.amount && !isNaN(this.amount)) {
      this.totalPrice = parseInt(this.inputValue) * this.amount;
    } else {
      this.totalPrice = 0;
    }
    this.payAmount = this.totalPrice * multiplier;
  }
  allowOnlyNumbers(event: KeyboardEvent, inputValue: string) {
    const charCode = event.which ? event.which : event.keyCode;
    // Allow only numbers (0-9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return;
    }
    // Prevent leading 0
    if (inputValue.length === 0 && charCode === 48) {
      event.preventDefault();
      return;
    }
  }

  createOnBoardClient() {
    try {
      if (this.clientRecordCreated && this.clientId) {
        this.continueProvisioningAfterClient();
        return;
      }
      const authId =
        this.onBoardingUserDetails.userTypeId == 1
          ? this.onBoardingUserDetails.authId
          : this.signupAuthInfo != undefined
            ? this.signupAuthInfo.authId
            : this.authId;
      const signInMethod =
        this.onBoardingUserDetails.userTypeId == 1
          ? this.onBoardingUserDetails.signInMethod
          : this.signupAuthInfo != undefined
            ? this.signupAuthInfo.signInMethod
            : this.signInMethod;
      const dialCode = '+' + this.phoneInputComponent.selectedCountry.dialCode;
      const isoCode = this.phoneInputComponent.selectedCountry.iso2
        .toString()
        .toUpperCase();
      const phoneNo = this.phoneInputComponent.phoneNumber;
      let data = {
        id: 0,
        logo: '',
        businessName: this.formSubmissionInfo.business.busiName,
        businessImage: '',
        businessWebsite: '',
        address1: this.formSubmissionInfo.business.address1,
        address2: this.formSubmissionInfo.business.address2,
        state: this.formSubmissionInfo.business.state,
        city: this.formSubmissionInfo.business.city,
        country: this.countryName,
        pincode: this.formSubmissionInfo.business.zipCode.trim(),
        planId: this.planId,
        subscriptionFrequencyId: this.subFreeId,
        onBoardingClient: true,
        personalInfo: {
          authId: authId,
          signInMethod: signInMethod,
          firstName: this.formSubmissionInfo.personal.firstName,
          lastName: this.formSubmissionInfo.personal.lastName,
          email: this.formSubmissionInfo.email.emailCtrl,
          images: '',
          countryCode: this.countryCode == undefined ? "" : this.countryCode,
          stdCode: dialCode,
          phoneNumber: phoneNo,
          smsNumber: this.formSubmissionInfo.personal.mobNumber,
          userRoleId: 0,
          userTypeId: 4,
          recordStatus: true,
          registerStatus: true,
          createdBy: 0,
        },
      };
      this.clientFacade.onboardClient(data).subscribe({
        next: (response) => {
          const responseText = this.normalizeTextResponse(response);
          if (responseText.toLowerCase() === 'invalid zipcode') {
            this.isProcessing = false;
            this.isFinalClick = false;
            this.isLoading = false;
            this.userFeedback.stopLoading();
            const businessZipCtrl = this.businessFormGroup?.get('zipCode');
            businessZipCtrl?.setErrors({
              ...(businessZipCtrl.errors || {}),
              invalidZip: true,
            });
            businessZipCtrl?.markAsTouched();
            if (this.stepper) {
              this.stepper.selectedIndex = 2;
            }
            this.notifyUi();
            this.subscriptionError('Invalid ZIP Code');
            return;
          }
          if (responseText === 'Already Exists') {
            const existingClientId = Number(
              this.clientId ||
              this.onBoardingUserDetails?.clientId ||
              (this.onBoardingUserDetails?.id
                ? Number(this.onBoardingUserDetails.id)
                : 0)
            );
            if (this.payment && Number.isFinite(existingClientId) && existingClientId > 0) {
              this.clientId = existingClientId;
              this.clientRecordCreated = true;
              this.continueProvisioningAfterClient();
              return;
            }
            this.isProcessing = false;
            this.isFinalClick = false;
            this.userFeedback.stopLoading();
            this.notifyUi();
            if (this.onBoardingUserDetails?.isDatabase == true) {
              this.setExistingClientLoginError();
            } else {
              this.passwordMessage = 'This email was already registered';
            }
          } else {
            const parsedId = parseInt(responseText, 10);
            if (!Number.isNaN(parsedId) && parsedId > 0) {
              this.clientId = parsedId;
              this.clientRecordCreated = true;
              this.continueProvisioningAfterClient();
            } else {
              this.handlePaymentFailure(
                responseText || 'Could not create your business record. Please try again or contact support.'
              );
            }
          }
        },
        error: (error) => {
          this.persistFormStateAfterSubmissionError(
            'Could not create your business account. Please try again.',
            error
          );
          this.deletefirebaseUser();
        },
      });
    } catch (error) {
      this.persistFormStateAfterSubmissionError(
        'Could not create your business account. Please try again.',
        error
      );
    }
  }

  subscribeTrialPeriod() {
    // First, parse the input date string using moment()
    const date = moment(new Date(), 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    // Format the date to ISO 8601 format with milliseconds in UTC
    const isoDate = date.toISOString();
    let data = {
      planId: parseInt(this.planId),
      clientId: parseInt(this.clientId),
      subscriptionStartDate: isoDate,
      createdBy: parseInt(this.clientId),
      subscriptionFrequencyId: this.subFreeId,
      isFreePlan: this.freePlan,
    };
    this.subscriptionFacadeService.subscribeTrial(data).subscribe({
      next: () => {
        this.completeOnboardingSuccess();
      },
      error: (error) => {
        this.persistFormStateAfterSubmissionError(
          'Could not complete trial registration. Please try again.',
          error
        );
      },
    });
  }

  navigate() {
    let targetUrl = '';
    // If embedded in an iframe on the website, document.referrer gives the exact website URL
    if (document.referrer) {
      try {
        const refUrl = new URL(document.referrer);
        // Replace partner/onboarding page with the site's index.html
        if (refUrl.pathname.toLowerCase().includes('onboarding') || refUrl.pathname.toLowerCase().includes('partner')) {
          refUrl.pathname = refUrl.pathname.replace(/\/?[^\/]*onboarding[^\/]*\.html$/i, '/index.html');
          refUrl.search = '';
          refUrl.hash = '';
          targetUrl = refUrl.toString();
        } else {
          targetUrl = `${refUrl.origin}/index.html`;
        }
      } catch (e) {
        // Fallback if parsing fails
      }
    }

    // Fallback based on environment domain if referrer is absent or external
    if (!targetUrl) {
      const domain = environment.domain || '';
      if (domain.includes('.com')) {
        targetUrl = 'https://visitmaker.com/index.html';
      } else {
        targetUrl = 'https://myvisitmaker.com/index.html';
      }
    }

    try {
      if (window.top && window.top !== window) {
        window.top.location.href = targetUrl;
      } else {
        window.location.href = targetUrl;
      }
    } catch (e) {
      window.location.href = targetUrl;
    }
  }

  verifyEmail(authInfo: any) {
    try {
      this.userFacadeService.verifyEmailFirebase(authInfo.authId).subscribe({
        next: (response) => {
          this.createOnBoardClient();
        },
        error: (error) => {
          this.persistFormStateAfterSubmissionError(
            'Could not verify your account. Please try again.',
            error
          );
        },
      });
    } catch (error) {
      this.persistFormStateAfterSubmissionError(
        'Could not verify your account. Please try again.',
        error
      );
    }
  }

  errorSocialMessage(e: any) {
    let errorMsg: string = e;
    if (e == 'email not match') {
      errorMsg =
        'Please use social media account having same email or create a new password.';
      this.passwordMessage = errorMsg;
    } else {
      if (e.code == 'auth/user-not-found') {
        errorMsg = 'Please enter the valid email address';
        this.passwordMessage = errorMsg;
      } else if (
        e.code == 'auth/wrong-password' ||
        e.code == 'auth/invalid-password'
      ) {
        errorMsg = 'Password is incorrect';
        this.passwordMessage = errorMsg;
      } else if (
        e.code == 'auth/email-already-in-use' ||
        e.code == 'auth/email-already-exists'
      ) {
        errorMsg = 'This email is already in use';
        this.passwordMessage = errorMsg;
      } else {
        errorMsg = 'Something went wrong, Please try again';
        this.passwordMessage = errorMsg;
      }
    }
  }

  setPasswordValidations() {
    this.personalFormGroup?.get('password')?.setValidators([
      Validators.required,
      Validators.minLength(8),
      Validators.pattern(
        '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'
      ),
    ]);
    this.personalFormGroup?.get('confirmPassword')?.setValidators([Validators.required]);
    this.personalFormGroup?.setValidators([
      MustMatch('password', 'confirmPassword'),
    ]);
    this.personalFormGroup?.get('password')?.updateValueAndValidity();
    this.personalFormGroup?.get('confirmPassword')?.updateValueAndValidity();
    this.personalFormGroup?.updateValueAndValidity();
  }

  removePasswordValidations() {
    this.personalFormGroup?.get('password')?.clearValidators();
    this.personalFormGroup?.get('password')?.updateValueAndValidity();
    this.personalFormGroup?.get('confirmPassword')?.clearValidators();
    this.personalFormGroup?.get('confirmPassword')?.updateValueAndValidity();
    this.personalFormGroup?.clearValidators();
    this.personalFormGroup?.updateValueAndValidity();
  }

  passwordClick() {
    this.showNewPassword = !this.showNewPassword;
    setTimeout(() => {
      this.showNewPassword = !this.showNewPassword;
    }, 3000);
  }

  confirmClick() {
    this.showConfirmPassword = !this.showConfirmPassword;
    setTimeout(() => {
      this.showConfirmPassword = !this.showConfirmPassword;
    }, 3000);
  }

  onCountrySelected(event: any) {
    this.country = event.value.countryName;
    this.fetchStateList();
  }

  getPlanDetailById(id) {
    try {
      this.userFeedback.startLoading();
      this.subscriptionFacadeService.getPlanById(id).subscribe({
        next: (res) => {
          if (res) {
            this.promoCodeValue = res[0]?.keyCode ?? this.keyCodeValue ?? '';
            if (this.promoCodeValue !== '') {
              this.promoPriceView = true;
            }
            this.locationCount = res[0].locationCount;
            this.keyCode = res[0]?.keyCode;
            const countryList = res[0].countryList;
            const priceList = res[0].pricing;
            if (countryList && countryList.length > 0) {
              const urlCountryId = Number(this.countryId);
              let matched = !Number.isNaN(urlCountryId)
                ? countryList.find(c => c.id === urlCountryId)
                : undefined;
              if (!matched && this.code) {
                const queryCode = this.code.trim().toUpperCase();
                matched = countryList.find(
                  c => (c.countryCode || '').toUpperCase() === queryCode
                );
              }
              if (!matched && this.countryCode) {
                matched = countryList.find(
                  c => (c.countryCode || '').toUpperCase() === this.countryCode.toUpperCase()
                );
              }
              if (matched) {
                this.countryId = matched.id;
                this.countryName = matched.countryName;
                if (matched.countryCode) {
                  this.countryCode = matched.countryCode;
                }
                this.syncPhoneCountryFromPlan();
              }
            }
            if (this.countryName) {
              this.businessFormGroup.get('country').setValue(this.countryName);
              this.locationFormGroup.get('country').setValue(this.countryName);
              this.fetchStateList();
            }
            if (priceList && priceList.length > 0) {
              const matchedPrices = priceList.find(c => c.countryId === this.countryId);
              if (matchedPrices) {
                if (this.subType === 'monthly' || this.subFreeId === 1) {
                  this.originalPrice = matchedPrices.monthly;
                  this.offerAmount = matchedPrices.offerMonthlyPrice && matchedPrices.offerMonthlyPrice !== 0
                    ? matchedPrices.offerMonthlyPrice
                    : matchedPrices.monthly;
                  this.hideOffer = matchedPrices.offerMonthlyPrice === 0;
                  this.amount = this.offerAmount;
                  this.existingAmount = this.offerAmount;
                  this.promoCodeRemove = matchedPrices.stripeMonthlyPriceId;
                  this.pricingId = matchedPrices.offerYearlyPrice !== 0 ? matchedPrices.offerStripeMonthlyPriceId : matchedPrices.stripeMonthlyPriceId;
                  this.exitingPricingId = matchedPrices.offerYearlyPrice !== 0 ? matchedPrices.offerStripeMonthlyPriceId : matchedPrices.stripeMonthlyPriceId;
                } else if (this.subType === 'quarterly' || this.subFreeId === 2) {
                  this.originalPrice = Math.round((matchedPrices.quarterly / 3) * 100) / 100;
                  this.offerAmount = matchedPrices.offerQuarterlyPrice && matchedPrices.offerQuarterlyPrice !== 0
                    ? matchedPrices.offerQuarterlyPrice
                    : matchedPrices.quarterly;
                  this.hideOffer = matchedPrices.offerQuarterlyPrice === 0;
                  this.amount = Math.round((this.offerAmount / 3) * 100) / 100;
                  this.existingAmount = Math.round((this.offerAmount / 3) * 100) / 100;
                  // this.pricingId = matchedPrices.stripeMonthlyPriceId;
                } else if (this.subType === 'yearly' || this.subFreeId === 3) {
                  this.originalPrice = Math.round((matchedPrices.yearly / 12) * 100) / 100;
                  this.offerAmount = matchedPrices.offerYearlyPrice && matchedPrices.offerYearlyPrice !== 0
                    ? matchedPrices.offerYearlyPrice
                    : matchedPrices.yearly;
                  this.hideOffer = matchedPrices.offerYearlyPrice === 0;
                  this.amount = Math.round((this.offerAmount / 12) * 100) / 100;
                  this.existingAmount = Math.round((this.offerAmount / 12) * 100) / 100;
                  this.promoCodeRemove = matchedPrices.stripeYearlyPriceId;
                  this.pricingId = matchedPrices.offerYearlyPrice !== 0 ? matchedPrices.offerStripeYearlyPriceId : matchedPrices.stripeYearlyPriceId;
                  this.exitingPricingId = matchedPrices.offerYearlyPrice !== 0 ? matchedPrices.offerStripeYearlyPriceId : matchedPrices.stripeYearlyPriceId;
                }
              }
            }
            this.planName = res[0].displayPlanName != null ? res[0].displayPlanName : res[0].planName;
            this.freePlan =
              res[0]?.planName?.toLowerCase() === 'free plan' ||
              res[0]?.displayPlanName?.toLowerCase() === 'free plan';
            this.trialPeriod = res[0].isTrialPeriod;
            if (this.freePlan == false && this.trialPeriod == false) {
              this.payment = true;
            } else if (this.freePlan == true || this.trialPeriod == true) {
              this.payment = false;
            } else {
              this.payment = !!this.payment;
            }
            this.initializeTotalPrice();
          }
          this.userFeedback.stopLoading();
          this.notifyUi();
        },
        error: (error) => {
          this.reportOnboardingApiError(
            'Could not load plan details. Please refresh and try again.',
            error
          );
        },
      });
    } catch (error) {
      this.reportOnboardingApiError(
        'Could not load plan details. Please refresh and try again.',
        error
      );
    }
  }

  fetchCountryList(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.locationFacadeService.getCountryList().subscribe({
        next: (response: any) => {
          this.countryList = response;
          this.isPageLoading = false;
          this.isProcessing = false;
          this.notifyParentOnboardingReady();
          this.restoreStepperStep();
          this.notifyUi();
          this.filteredCountry = this.countryFilterCtrl.valueChanges.pipe(
            startWith(''),
            map((countryName: any) =>
              countryName ? this.filterCountry(countryName) : this.countryList
            )
          );
          resolve();
        },
        error: (error) => {
          this.reportOnboardingApiError(
            'Could not load countries. Please refresh and try again.',
            error
          );
          resolve();
        },
      });
    });
  }

  fetchStateList(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.locationFacadeService.getStateList(this.countryName).subscribe({
        next: (response: any) => {
          this.stateList = response;
          this.isProcessing = false;
          this.filteredState = this.stateFilterCtrl.valueChanges.pipe(
            startWith(''),
            map((state: any) =>
              state ? this.filterState(state) : this.stateList
            )
          );
          resolve();
        },
        error: (error) => {
          this.isProcessing = false;
          if (!navigator.onLine) {
            this.subscriptionError(
              'You are offline. Please check your internet connection.'
            );
          } else {
            // handle error.
            this.subscriptionError('Something went wrong, Please try again.');
          }
          resolve();
        },
      });
    });
  }

  normalizeTimeZoneValue(value: any): string {
    if (value == null) {
      return '';
    }
    if (typeof value === 'string' || typeof value === 'number') {
      return value.toString().trim();
    }
    return (
      value.timeZone ||
      value.timeZoneId ||
      value.timezone ||
      value.displayName ||
      value.ianaName ||
      value.name ||
      ''
    ).toString().trim();
  }

  getTimeZoneOptionValue(item: any): string {
    return this.normalizeTimeZoneValue(item);
  }

  getTimeZoneDisplay(item: any): string {
    return this.normalizeTimeZoneValue(item);
  }

  private extractTimeZoneOptions(response: any): any[] {
    if (Array.isArray(response)) {
      return response.filter(Boolean);
    }
    if (Array.isArray(response?.data)) {
      return response.data.filter(Boolean);
    }
    if (Array.isArray(response?.timeZones)) {
      return response.timeZones.filter(Boolean);
    }
    return [];
  }

  private resolveTimeZoneInList(saved: any, list: any[]): string | null {
    const target = this.normalizeTimeZoneValue(saved);
    if (!target || !Array.isArray(list) || list.length === 0) {
      return null;
    }
    const targetLower = target.toLowerCase();
    const match = list.find((item) => {
      const candidates = [
        item?.timeZone,
        item?.timeZoneId,
        item?.timezone,
        item?.displayName,
        item?.ianaName,
        item?.name,
        item?.id,
      ].map((entry) => this.normalizeTimeZoneValue(entry).toLowerCase());
      return candidates.includes(targetLower);
    });
    return match ? this.getTimeZoneOptionValue(match) : null;
  }

  private applySavedTimeZone(saved: any): void {
    const control = this.locationFormGroup?.get('timeZone');
    if (!control) {
      return;
    }
    const raw = this.normalizeTimeZoneValue(saved);
    const resolved = this.resolveTimeZoneInList(raw, this.timeZoneList || []);
    if (resolved) {
      this.timeZoneUnresolved = false;
      control.setValue(resolved, { emitEvent: false });
      const errors = { ...(control.errors || {}) };
      delete errors['unresolvedTimeZone'];
      control.setErrors(Object.keys(errors).length ? errors : null);
      return;
    }
    const fallback = raw || this.normalizeTimeZoneValue(this.originalEditTimeZone);
    if (fallback) {
      this.timeZoneUnresolved = true;
      control.setValue(fallback, { emitEvent: false });
      control.setErrors({ ...(control.errors || {}), unresolvedTimeZone: true });
      control.markAsTouched();
      return;
    }
    this.timeZoneUnresolved = false;
  }

  private preserveTimeZoneOnSave(existingLoc: any, incomingLoc: any): string {
    return (
      this.normalizeTimeZoneValue(incomingLoc?.timeZone) ||
      this.normalizeTimeZoneValue(existingLoc?.timeZone) ||
      this.normalizeTimeZoneValue(this.originalEditTimeZone)
    );
  }

  private assertTimeZoneReadyForSave(timeZone: string): boolean {
    const control = this.locationFormGroup?.get('timeZone');
    if (!timeZone) {
      control?.setErrors({ ...(control?.errors || {}), required: true });
      control?.markAsTouched();
      return false;
    }
    if (this.timeZoneList?.length) {
      const resolved = this.resolveTimeZoneInList(timeZone, this.timeZoneList);
      if (!resolved) {
        this.timeZoneUnresolved = true;
        control?.setErrors({ ...(control?.errors || {}), unresolvedTimeZone: true });
        control?.markAsTouched();
        return false;
      }
    }
    return true;
  }

  private populateLocationForm(location: any, index: number | null): void {
    if (!location) {
      return;
    }
    this.originalEditTimeZone = this.normalizeTimeZoneValue(location.timeZone);
    this.timeZoneUnresolved = false;
    this.timeZoneFilterCtrl.setValue('', { emitEvent: false });
    this.locationFormGroup.patchValue(
      {
        locationName: location.locationName || '',
        address1: location.address1 || '',
        address2: location.address2 || '',
        city: location.city || '',
        country: location.country || this.countryName || '',
        state: location.state || '',
        timeZone: this.originalEditTimeZone,
        zipCode: location.zipCode || '',
      },
      { emitEvent: false }
    );
    this.locationFormGroup.get('zipCode')?.enable({ emitEvent: false });
    this.locationFormGroup.get('timeZone')?.enable({ emitEvent: false });
    if (index !== null && index !== undefined) {
      this.editIndex = index;
      this.locationEdit = true;
    }
    if (location.state) {
      this.getTimeZoneList(location.state, { restoreTimeZone: this.originalEditTimeZone });
    } else if (this.originalEditTimeZone) {
      this.timeZoneUnresolved = true;
      const control = this.locationFormGroup.get('timeZone');
      control?.setErrors({ ...(control?.errors || {}), unresolvedTimeZone: true });
      control?.markAsTouched();
    }
  }

  getTimeZoneList(selectedState, options?: { restoreTimeZone?: string }): Promise<void> {
    return new Promise((resolve) => {
      if (!selectedState) {
        this.timeZoneList = [];
        this.filteredTimeZone = of([]);
        this.emptyProvinceTimeZone = true;
        resolve();
        return;
      }
      if (this.timeZoneLoadSub) {
        this.timeZoneLoadSub.unsubscribe();
      }
      this.timeZoneLoadSub = this.locationFacadeService.getTimezone({ State: selectedState }).subscribe({
        next: (response: any) => {
          this.timeZoneList = this.extractTimeZoneOptions(response);
          this.isProcessing = false;
          this.timeZoneFilterCtrl.setValue('', { emitEvent: false });
          this.emptyProvinceTimeZone = !this.timeZoneList.length;
          this.filteredTimeZone = this.timeZoneFilterCtrl.valueChanges.pipe(
            startWith(''),
            map((timeZone: any) =>
              timeZone ? this.filterTimeZone(timeZone) : this.timeZoneList
            )
          );
          this.cdr.detectChanges();
          if (options && 'restoreTimeZone' in options) {
            this.applySavedTimeZone(options.restoreTimeZone);
            this.cdr.detectChanges();
          }
          resolve();
        },
        error: () => {
          this.isProcessing = false;
          this.timeZoneList = [];
          this.filteredTimeZone = of([]);
          this.emptyProvinceTimeZone = true;
          if (options && 'restoreTimeZone' in options) {
            this.applySavedTimeZone(options.restoreTimeZone);
          }
          if (!navigator.onLine) {
            this.subscriptionError(
              'You are offline. Please check your internet connection.'
            );
          } else {
            this.subscriptionError('Something went wrong, Please try again.');
          }
          resolve();
        },
      });
    });
  }

  filterState(name: any) {
    let arr = this.stateList.filter((stateList) =>
      stateList.state.toLowerCase().includes(name.toLowerCase())
    );
    return arr.length ? arr : [{ name: 'No Item found', code: 'null' }];
  }

  filterCountry(name: any) {
    let arr = this.countryList.filter((countryList) =>
      countryList.countryName.toLowerCase().includes(name.toLowerCase())
    );
    return arr.length ? arr : [{ name: 'No Item found', code: 'null' }];
  }

  filterLocation(name: any) {
    let arr = this.locationList.filter((location) =>
      location.locationName.toLowerCase().includes(name.toLowerCase())
    );
    return arr.length ? arr : [{ name: 'No Item found', code: 'null' }];
  }

  filterTimeZone(name: any) {
    let arr = this.timeZoneList.filter((timeZone) =>
      timeZone.timeZone.toLowerCase().includes(name.toLowerCase())
    );
    return arr.length ? arr : [{ name: 'No Item found', code: 'null' }];
  }
  //When the payment failed user reattempt
  updataOnboardClient() {
    try {
      const authId = this.onBoardingUserDetails.authId;
      const signInMethod = this.onBoardingUserDetails.signInMethod;
      const dialCode = '+' + this.phoneInputComponent.selectedCountry.dialCode;
      const isoCode = this.phoneInputComponent.selectedCountry.iso2
        .toString()
        .toUpperCase();
      const phoneNo = this.phoneInputComponent.phoneNumber;
      let data = {
        id: this.clientId,
        userId: this.userId,
        logo: '',
        businessName: this.formSubmissionInfo.business.busiName,
        businessImage: '',
        businessWebsite: '',
        address1: this.formSubmissionInfo.business.address1,
        address2: this.formSubmissionInfo.business.address2,
        state: this.formSubmissionInfo.business.state,
        city: this.formSubmissionInfo.business.city,
        country: this.formSubmissionInfo.business.country.countryName,
        pincode: this.formSubmissionInfo.business.zipCode.trim(),
        personalInfo: {
          authId: this.authId,
          signInMethod: signInMethod,
          firstName: this.formSubmissionInfo.personal.firstName,
          lastName: this.formSubmissionInfo.personal.lastName,
          email: this.formSubmissionInfo.email.emailCtrl,
          images: '',
          countryCode: isoCode,
          stdCode: dialCode,
          phoneNumber: phoneNo,
          smsNumber: this.formSubmissionInfo.personal.mobNumber,
          userRoleId: 0,
          userTypeId: 2,
          recordStatus: true,
          registerStatus: true,
          createdBy: this.clientId,
        },
      };
      this.clientFacade.updateOnboardClient(data).subscribe({
        next: (response) => {
          // if (response == 'Invalid ZipCode') {
          //   this.isProcessing = false;
          //   this.snackBar.errorSnackbar('Invalid zipCode');
          // } else
          if (response == 'Already Exists') {
            this.isFinalClick = false;
            this.passwordMessage = 'This email was already registered';
            this.clearSubmissionLoadingState();
          } else {
            if (this.countryId == 233) {
              this.createToken();
            } else {
              this.createSubscription();
            }
          }
        },
        error: (error) => {
          this.clearSubmissionLoadingState();
          if (!navigator.onLine) {
            this.subscriptionError(
              'Your payment process was interrupted. Please try again.'
            );
          } else {
            // handle error.
            this.subscriptionError('Something went wrong, Please try again.');
          }
        },
      });
    } catch (error) {
      this.clearSubmissionLoadingState();
      // handle error
      if (!navigator.onLine) {
        this.subscriptionError(
          'Your payment process was interrupted. Please try again.'
        );
      } else {
        // handle error.
        this.subscriptionError('Something went wrong, Please try again.');
      }
    }
  }

  // Delete the user if the payment failed user retried
  deletefirebaseUser() {
    this.authServiceFacade
      .deleteUser()
      .then((res) => {
        // this.firebaseSignup();
      })
      .catch((error) => {
        //this.subscriptionError(error);
      });
  }

  //error handling
  subscriptionError(errorMsg) {
    this.errorSnackBar.open(errorMsg, 'X', {
      verticalPosition: 'top',
      panelClass: ['error-snackbar'],
      duration: 2000,
    });
  }

  get serviceProviderCount(): number {
    return this.nextClickStylistList?.length || this.stylistList?.length || 0;
  }

  get cardholderDisplayName(): string {
    const first = (this.personalFormGroup?.get('firstName')?.value || '').trim();
    const last = (this.personalFormGroup?.get('lastName')?.value || '').trim();
    return `${first} ${last}`.trim();
  }

  get serviceProviderSummaryLabel(): string {
    const count = this.serviceProviderCount;
    return count === 1 ? '1 Service Provider' : `${count} Service Providers`;
  }

  get billingFrequencyBadge(): string {
    if (this.subType === 'yearly') {
      return 'Paid Yearly';
    }
    if (this.subType === 'quarterly') {
      return 'Paid Quarterly';
    }
    return 'Paid Monthly';
  }

  getPaymentStepIndex(): number {
    return this.payment ? 5 : 4;
  }

  private handlePaymentFailure(message: string, raw?: unknown): void {
    const reason = this.resolvePaymentFailureMessage(message, raw);
    this.paymentFailureReason = reason;
    this.paymentErrorMessage = reason;
    this.subscriptionChargeConfirmed = false;
    this.paySuccess = false;
    this.paymentInProgress = false;
    this.clearSubmissionLoadingState();

    if (this.onboardingRegistrationComplete && this.clientId) {
      this.paymentRecoveryMode = true;
      this.notifyUi();
      return;
    }

    this.paymentRecoveryMode = false;
    this.subscriptionError(reason);
    if (this.payment && this.stepper) {
      this.stepper.selectedIndex = this.getPaymentStepIndex();
    }
    this.notifyUi();
  }

  private clearPaymentFailure(): void {
    this.paymentErrorMessage = null;
    this.paymentFailureReason = '';
    this.paymentRecoveryMode = false;
  }

  dismissPaymentRecoveryAndRetry(): void {
    this.paymentRecoveryMode = false;
    this.paymentErrorMessage = null;
    this.paymentFailureReason = '';
    this.stylistPostPaymentHandled = false;
    this.paymentInProgress = true;
    if (this.stepper) {
      this.stepper.selectedIndex = this.getPaymentStepIndex();
    }
    this.retryPayment();
  }

  onPayClick(): void {
    if (this.userFeedback.loading || this.isPageLoading) {
      return;
    }
    this.clearPaymentFailure();
    this.submitOnboardingForm();
  }

  retryPayment(): void {
    if (this.userFeedback.loading || this.isPageLoading) {
      return;
    }
    this.clearPaymentFailure();
    if (!this.clientId) {
      this.submitOnboardingForm();
      return;
    }
    if (this.payment) {
      this.userFeedback.startLoading();
      this.isFinalClick = true;
      if (!this.ensureFormSubmissionSnapshot()) {
        this.handlePaymentFailure('Please complete all steps before paying.');
        return;
      }
      if (this.countryId == 233) {
        this.paymentInProgress = true;
        this.notifyUi();
        setTimeout(() => this.beginUsStripePayment(0), 0);
      } else {
        this.createSubscription();
      }
    }
  }

  onBusinessNext(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.isLoading) {
      return;
    }
    const zipControl = this.businessFormGroup.get('zipCode');
    const zipCode = (zipControl?.value || '').toString().trim();
    if (zipCode && !this.isValidZipFormat(zipCode, this.countryCode)) {
      zipControl?.setErrors({ ...(zipControl.errors || {}), invalidZip: true });
      zipControl?.markAsTouched();
      return;
    }
    Object.values(this.businessFormGroup.controls).forEach(c => c.markAsTouched());
    if (this.businessFormGroup.invalid) {
      return;
    }
    // If debounced backend ZIP validation hasn't completed for this exact ZIP yet,
    // validate now before advancing to Step 4.
    if (zipCode !== this.lastValidatedZip['business']) {
      if (this.zipCodeTimeouts['business']) {
        clearTimeout(this.zipCodeTimeouts['business']);
      }
      this.zipCodeValidation('business', () => {
        if (!this.businessFormGroup.invalid) {
          this.completedSteps[2] = true;
          this.saveDraftToStorage();
          if (this.stepper) {
            this.stepper.selectedIndex = 3;
          }
        }
      });
      return;
    }
    this.completedSteps[2] = true;
    this.saveDraftToStorage();
    if (this.stepper) {
      this.stepper.selectedIndex = 3;
    }
  }

  onLocationNext(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.isLoading) {
      return;
    }
    this.addLocationNext();
  }


  //success handling
  subscriptionSuccess(sucMsg) {
    this.errorSnackBar.open(sucMsg, 'X', {
      verticalPosition: 'top',
      panelClass: ['success-snackbar'],
      duration: 1000,
    });
  }

  //To get the client details for prefill if the payment was failed user retried
  getClientById(id) {
    this.clientFacade.getClientById(id).subscribe({
      next: (response) => {
        try {
          const row = response?.[0];
          if (!row) {
            this.persistFormStateAfterSubmissionError(
              'Could not load your account details. Please try again.'
            );
            return;
          }
          this.userId = row.userId;
          this.authId = row.authId;
          if (this.userId) {
            this.updataOnboardClient();
          } else if (this.clientId) {
            this.clientRecordCreated = true;
            this.continueProvisioningAfterClient();
          } else {
            this.clearSubmissionLoadingState();
            this.subscriptionError('Unable to resume onboarding. Please contact support.');
          }
          this.personalFormGroup.patchValue({
            firstName: row.firstName,
            lastName: row.lastName,
            mobNumber: row.smsNumber,
          });
          this.businessFormGroup.patchValue({
            busiName: row.businessName,
            address1: row.address1,
            address2: row.address2,
            city: row.city,
            country: row.country,
            state: row.state,
            zipCode: row.pincode,
          });
        } catch (e) {
          this.persistFormStateAfterSubmissionError(
            'Could not load your account details. Please try again.',
            e
          );
        }
      },
      error: (error) => {
        this.persistFormStateAfterSubmissionError(
          'Could not load your account details. Please try again.',
          error
        );
      },
    });
  }

  onCardChange(event: StripeCardElementChangeEvent): void {
    this.cardComplete = event.complete;
    if (event.error) {
      this.cardErrors = event.error.message;
    } else {
      this.cardErrors = null;
    }
  }

  //only allowing numbers in input
  keyPressNumbers(event: any) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  onCountryChange(event) {
    if (event.iso2 !== 'us' && event.iso2 !== 'in') {
      this.selectedCountry = {
        name: 'United States',
        iso2: 'us',
        dialCode: '1',
        priority: 0,
        flagClass: 'US',
      };
      this.phoneInputComponent.selectedCountry = this.selectedCountry;
    } else {
      this.selectedCountry = event; // Otherwise, keep the selected country
    }
  }
  compareLocations = (loc1: any, loc2: any): boolean => {
    if (!loc1 || !loc2) return loc1 === loc2;
    if (loc1.id !== undefined && loc2.id !== undefined && loc1.id !== null && loc2.id !== null) {
      return loc1.id === loc2.id;
    }
    if (loc1.locationName && loc2.locationName) {
      return loc1.locationName.trim().toLowerCase() === loc2.locationName.trim().toLowerCase();
    }
    return loc1 === loc2;
  };

  updateFilteredLocations(searchStr: string = ''): void {
    const list = this.locationList || [];
    const query = (typeof searchStr === 'string' ? searchStr : '').trim().toLowerCase();
    const filtered = query
      ? list.filter((loc: any) => (loc?.locationName || '').toLowerCase().includes(query))
      : [...list];
    this.filteredLocation = of(filtered);
    this.emptyProvinceLocation = filtered.length === 0;
  }

  onLocationSelected(event: any): void {
    const selected = event?.value;
    if (selected) {
      this.stylistFormGroup.get('location')?.setValue(selected);
      this.saveDraftToStorage();
    }
  }
  changeState(event) {
    const selectedState = event.value;
    if (selectedState) {
      if (this.locationList.length != 0) {
        this.addValidate = true;
      }
      this.businessFormGroup.get('zipCode')?.enable();
    } else {
      this.businessFormGroup.get('zipCode')?.disable();
      this.businessFormGroup.get('zipCode')?.reset();
    }
    this.businessFormGroup.get('zipCode')?.setValue('');
  }
  changeLocationState(event) {
    const selectedState = event.value;
    if (selectedState) {
      if (this.locationList.length != 0) {
        this.addValidate = true;
      }
      this.timeZoneUnresolved = false;
      this.originalEditTimeZone = '';
      this.locationFormGroup.get('timeZone')?.setValue('', { emitEvent: false });
      this.locationFormGroup.get('timeZone')?.enable({ emitEvent: false });
      this.getTimeZoneList(selectedState);
      this.locationFormGroup.get('zipCode')?.enable();
    } else {
      this.locationFormGroup.get('zipCode')?.disable();
      this.locationFormGroup.get('zipCode')?.reset();
      this.locationFormGroup.get('timeZone')?.setValue('', { emitEvent: false });
    }
    this.locationFormGroup.get('zipCode')?.setValue('');
  }
  changeTimeZone(event) {
    const selected = this.normalizeTimeZoneValue(event?.value);
    if (!selected) {
      return;
    }
    const resolved = this.resolveTimeZoneInList(selected, this.timeZoneList || []);
    const control = this.locationFormGroup.get('timeZone');
    if (resolved) {
      this.timeZoneUnresolved = false;
      control?.setValue(resolved, { emitEvent: false });
      const errors = { ...(control?.errors || {}) };
      delete errors['unresolvedTimeZone'];
      control?.setErrors(Object.keys(errors).length ? errors : null);
    }
  }
  //To verify the email status in both FB and DB
  checkEmailinFBandDB(emailOrEvent?: any): Promise<void> {
    return new Promise((resolve, reject) => {
      const clientEmail = (this.emailFormGroup?.get('emailCtrl')?.value || '').trim().toLowerCase();
      const email = (typeof emailOrEvent === 'string' && emailOrEvent.trim())
        ? emailOrEvent.trim().toLowerCase()
        : clientEmail;

      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        // Reject if email is invalid
        reject('Invalid email format');
        return;
      }

      const isClientLookup = email === clientEmail;
      if (isClientLookup) {
        if (this.clientEmailDebounceTimer) {
          clearTimeout(this.clientEmailDebounceTimer);
          this.clientEmailDebounceTimer = undefined;
        }
        this.lastValidatedClientEmail = email;
      }

      // Check session cache first
      if (this.emailInFBandDBCache.has(email)) {
        const cached = this.emailInFBandDBCache.get(email);
        this.processEmailFBandDBResponse(cached, email);
        resolve();
        return;
      }

      if (isClientLookup && this.clientEmailSubscription) {
        this.clientEmailSubscription.unsubscribe();
        this.clientEmailSubscription = undefined;
      }

      const sub = this.clientFacade.checkEmailFBandDB(email).subscribe({
        next: (response) => {
          if (isClientLookup) {
            this.clientEmailSubscription = undefined;
            const latestClientEmail = (this.emailFormGroup?.get('emailCtrl')?.value || '').trim().toLowerCase();
            if (latestClientEmail !== email) {
              // Ignore outdated response if user changed the client email
              resolve();
              return;
            }
          }
          this.emailInFBandDBCache.set(email, response);
          this.processEmailFBandDBResponse(response, email);
          resolve();
        },
        error: (error) => {
          if (isClientLookup) {
            this.clientEmailSubscription = undefined;
            this.lastValidatedClientEmail = '';
          }
          this.persistFormStateAfterSubmissionError(
            'Could not verify your email. Please try again.',
            error
          );
          reject(error);
        },
      });

      if (isClientLookup) {
        this.clientEmailSubscription = sub;
      }
    });
  }

  private processEmailFBandDBResponse(response: any, email: string): void {
    const clientEmail = (this.emailFormGroup?.get('emailCtrl')?.value || '').trim().toLowerCase();
    const isClientEmail = email === clientEmail;

    if (isClientEmail) {
      this.onBoardingUserDetails = response;
      this.clientEmailValidationResult = response;
      this.clientId = response.clientId || 0;
    }

    // CASE 1: Existing Client / Business User (userTypeId = 4 or userType = 'Client')
    if (response.userTypeId === 4 || response.userType === 'Client') {
      this.hidePasswords = true;
      this.removePasswordValidations();
      this.customer = false;
      this.userFeedback.stopLoading();
      this.setExistingClientLoginError();
      if (this.stepper) {
        this.stepper.selectedIndex = 0;
      }
      return;
    }

    // CASE 2: Service Provider
    if (
      response.userType === 'ServiceProvider' &&
      response.unPaidUser === false
    ) {
      this.hidePasswords = true;
      this.removePasswordValidations();
      this.customer = false;
      this.emailError = true;
      if (this.stepper?.selectedIndex === 3) {
        this.subscriptionSuccess(
          'Your payment has been successfully processed. Please log in to business.visitmaker.com.'
        );
        this.paySuccess = true;
        this.isProcessing = false;
        this.userFeedback.stopLoading();
      } else {
        if (this.stepper) this.stepper.selectedIndex = 0;
        this.setExistingClientLoginError();
      }
      this.stopRegistration = true;
      this.emailFormGroup?.controls['emailCtrl']?.setErrors({ incorrect: true });
      return;
    } else if (
      response.userType === 'ServiceProvider' &&
      response.userTypeId === 3 &&
      response.unPaidUser !== true
    ) {
      this.hidePasswords = true;
      this.removePasswordValidations();
      this.customer = false;
      this.emailError = true;
      this.errorMsg = '*You are already registered as a service provider. Please contact support@visitmaker.com';
      this.stopRegistration = true;
      this.emailFormGroup?.controls['emailCtrl']?.setErrors({ incorrect: true });
      if (this.stepper) this.stepper.selectedIndex = 1;
      return;
    }

    // CASE 3: Customer (userTypeId = 5 or userType = 'Customer')
    if (response.userType === 'Customer' || response.userTypeId === 5) {
      if (
        response.isFirebaseRegistered === true &&
        response.registerStatus === false
      ) {
        this.hidePasswords = true;
        this.customer = true;
        this.passwordMessage =
          '*As you have previously initiated the onboarding process, your personal details are already with us. Please provide your business details alone to continue with the onboarding process.';
        this.removePasswordValidations();
        this.personalFormGroup?.patchValue({
          firstName: response.firstName || '',
          lastName: response.lastName || '',
          mobNumber: response.smsNumber || '',
        });
        this.removePasswordValidations();
        this.stopRegistration = false;
        this.emailError = false;
        this.showExistingAccountLoginMessage = false;
      } else if (response.isFirebaseRegistered === false) {
        // Customer exists in DB but missing Firebase:
        // Keep customer = false so password fields render for creating their Firebase account
        this.customer = false;
        this.hidePasswords = false;
        this.setPasswordValidations();
        this.stopRegistration = false;
        this.emailError = false;
        this.showExistingAccountLoginMessage = false;
        this.passwordMessage = '';
        if (response.firstName || response.smsNumber) {
          this.personalFormGroup?.patchValue({
            firstName: response.firstName || '',
            lastName: response.lastName || '',
            mobNumber: response.smsNumber || '',
          });
        }
        // Identity resolution: if id: 0 and isDatabase: true, resolve actual customer identity
        if (response.id === 0 && response.isDatabase === true) {
          this.userFacadeService.GetUserByEmailOnBoarding(email).subscribe({
            next: (userRecord: UserOnboarding) => {
              if (userRecord?.id) {
                this.onBoardingUserDetails.id = userRecord.id;
                if (this.clientEmailValidationResult) {
                  this.clientEmailValidationResult.id = userRecord.id;
                }
              }
              if (userRecord?.authId) {
                this.onBoardingUserDetails.authId = userRecord.authId;
                this.onBoardingUserDetails.isFirebaseRegistered = true;
                if (this.clientEmailValidationResult) {
                  this.clientEmailValidationResult.authId = userRecord.authId;
                  this.clientEmailValidationResult.isFirebaseRegistered = true;
                }
              }
            },
            error: () => { }
          });
        }
      }
      return;
    }

    // Default / New User
    if (response.authId == null && response.isDatabase === false) {
      this.clientId = response.clientId || 0;
      if (this.clientId !== 0) {
        this.getClientById(this.clientId);
      }
      this.hidePasswords = false;
      this.customer = false;
      this.setPasswordValidations();
      this.stopRegistration = false;
      this.emailError = false;
      this.showExistingAccountLoginMessage = false;
      this.passwordMessage = '';
    }
  }

  //for adding billing details
  updateBillingAddress() {
    let data = {
      clientName: this.formSubmissionInfo.personal.firstName + "" + this.formSubmissionInfo.personal.lastName,
      clientEmail: this.emailFormGroup.get('emailCtrl').value,
      address1: this.formSubmissionInfo.business.address1,
      address2: this.formSubmissionInfo.business.address2,
      city: this.formSubmissionInfo.business.city,
      province: this.formSubmissionInfo.business.state,
      country: this.formSubmissionInfo.business.country.countryName,
      zipCode: this.formSubmissionInfo.business.zipCode,
      phoneNumber: this.formSubmissionInfo.personal.mobNumber,
      clientCountryId: this.countryId
    }
    this.subscriptionFacadeService.updateBillingAddress(data).subscribe({
      next: (response) => {
        //this.userFeedback.stopLoading();
      },
      error: (error) => {
        this.snackBar.errorSnackbar("Something went wrong, please try again");
        this.userFeedback.stopLoading();
      },
    });
  }

  // Opens RazorPay checkout window
  launchRazorPayCheckout(res: any) {
    const options: any = {
      key: environment.RAZOR_KEY,
      subscription_id: res,
      name: 'VisitMaker Subscription',
      description: 'Monthly Subscription Plan with Auto-Renewal',
      handler: (response: any) => {
        this.clearPaymentFailure();
        this.userFeedback.startLoading();
        this.storeRpDetails(response);
      },
      modal: {
        ondismiss: () => {
          this.handlePaymentFailure(
            'Payment was cancelled. You can retry payment when ready.'
          );
        },
      },
      prefill: {
        name: this.formSubmissionInfo.personal.firstName + "" + this.formSubmissionInfo.personal.lastName,
        email: this.emailFormGroup.get('emailCtrl').value,
        contact: this.formSubmissionInfo.personal.mobNumber,
      },
      theme: {
        color: '#fb9400',
      },
      method: {
        card: '1'  // Enable card option by default
      },
      subscription_card: {
        allow: true,  // Allows card saving
        save: true  // Enables auto-renewal
      }
      // Save card option
    };
    const rzp1 = new Razorpay(options);
    rzp1.on('payment.failed', (response: any) => {
      const description =
        response?.error?.description ||
        response?.error?.reason ||
        'Payment failed. Please try again.';
      this.handlePaymentFailure(description);
    });
    this.userFeedback.stopLoading();
    this.isProcessing = false;
    rzp1.open();
  }

  storeRpDetails(res) {
    this.userFeedback.startLoading();
    let data = {
      "clientId": this.clientId,
      "clientEmail": this.emailFormGroup.get('emailCtrl').value,
      "paymentId": res.razorpay_payment_id,
      "subscriptionId": res.razorpay_subscription_id,
      "pricingId": this.pricingId,
      "isImmediate": false,
      "quantity": this.nextClickStylistList.length || this.stylistList.length,
      "unUsedSubscriptionAmount": 0,
      "payAmount": this.payAmount,
      "isSelectAll": true,
      "stylistIds": [0],
      "walletAmountUsed": 0,
      "walletAmountRemaining": 0,
    }
    this.subscriptionFacadeService.storeRpDetails(data).subscribe({
      next: () => {
        this.completeOnboardingSuccess();
        this.sharedService.viewVariableReference(true);
      },
      error: () => {
        this.handlePaymentFailure(
          'Failed to complete payment registration. Please try again.'
        );
      }
    });
  }

  isLocationFormEmpty(): boolean {
    if (!this.locationFormGroup) return true;
    const fields = ['locationName', 'address1', 'city', 'state', 'timeZone', 'zipCode'];
    return fields.every(field => {
      const val = this.locationFormGroup.get(field)?.value;
      return val === null || val === undefined || val.toString().trim() === '';
    });
  }

  isStylistFormEmpty(): boolean {
    if (!this.stylistFormGroup) return true;
    const locationVal = this.stylistFormGroup.get('location')?.value;
    const emailVal = this.stylistFormGroup.get('email')?.value;
    const locationEmpty =
      locationVal === null ||
      locationVal === undefined ||
      (typeof locationVal === 'string' && locationVal.trim() === '') ||
      (typeof locationVal === 'object' && !locationVal?.locationName);
    const emailEmpty =
      emailVal === null || emailVal === undefined || emailVal.toString().trim() === '';
    return locationEmpty && emailEmpty;
  }

  private setExistingClientLoginError(): void {
    this.emailError = true;
    this.showExistingAccountLoginMessage = true;
    this.errorMsg = '';
    this.stopRegistration = true;
    this.emailFormGroup?.controls['emailCtrl']?.setErrors({ incorrect: true });
  }

  addLocation() {
    if (this.isLoading) {
      return;
    }
    const zipControl = this.locationFormGroup.get('zipCode');
    const hadInvalidZip = !!zipControl?.hasError('invalidZip');
    const zipVal = (zipControl?.value || '').toString().trim();
    const requiredFields = ['locationName', 'address1', 'city', 'timeZone', 'state', 'zipCode'];
    requiredFields.forEach(field => {
      const control = this.locationFormGroup.get(field);
      control?.setValidators([Validators.required]);
      control?.updateValueAndValidity({ emitEvent: false });
      control?.markAsTouched();
    });
    if (hadInvalidZip || (zipVal && !this.isValidZipFormat(zipVal, this.countryCode))) {
      zipControl?.setErrors({ ...(zipControl.errors || {}), invalidZip: true });
    }
    if (this.locationFormGroup.invalid) {
      this.locationNextClick = false;
      return;
    }
    if (zipVal !== this.lastValidatedZip['location']) {
      if (this.zipCodeTimeouts['location']) {
        clearTimeout(this.zipCodeTimeouts['location']);
      }
      this.zipCodeValidation('location', () => {
        if (!this.locationFormGroup.invalid) {
          this.addLocation();
        }
      });
      return;
    }
    const newLocation = this.locationFormGroup.getRawValue();
    const existingLoc = this.editIndex !== null ? (this.locationList[this.editIndex] || {}) : {};
    const preservedTimeZone = this.preserveTimeZoneOnSave(existingLoc, newLocation);
    if (!this.assertTimeZoneReadyForSave(preservedTimeZone)) {
      this.locationNextClick = false;
      return;
    }
    newLocation.timeZone = preservedTimeZone;
    // Check for duplicates
    const isDuplicate = this.locationList.some((loc, index) =>
      index !== this.editIndex && // exclude self when editing
      loc.locationName?.trim().toLowerCase() === newLocation.locationName?.trim().toLowerCase() &&
      loc.address1?.trim().toLowerCase() === newLocation.address1?.trim().toLowerCase() &&
      loc.city?.trim().toLowerCase() === newLocation.city?.trim().toLowerCase() &&
      loc.state?.trim().toLowerCase() === newLocation.state?.trim().toLowerCase() &&
      (loc.country || this.countryName || '')?.toString().trim().toLowerCase() ===
      (newLocation.country || this.countryName || '')?.toString().trim().toLowerCase() &&
      loc.zipCode?.trim().toLowerCase() === newLocation.zipCode?.trim().toLowerCase()
    );

    if (isDuplicate) {
      this.locationError = true;
      this.locationNextClick = false;
      return;
    } else {
      this.locationError = false;
      this.locationNextClick = true;
    }
    if (this.editIndex !== null) {
      // Update mode: preserve existing location ID and metadata if present
      this.locationList[this.editIndex] = {
        ...existingLoc,
        ...newLocation,
        timeZone: preservedTimeZone,
        country: newLocation.country || existingLoc.country || this.countryName || '',
      };
      this.editIndex = null;
      this.originalEditTimeZone = '';
      this.isLocationCountReached = false;
      this.locationEdit = true;
    } else {
      // Add new location
      this.locationList.push({
        ...newLocation,
        timeZone: preservedTimeZone,
        country: newLocation.country || this.countryName || '',
      });
      this.locationEdit = false;
    }
    if (this.locationCount === -1) {
      this.isLocationCountReached = false;
    } else {
      this.isLocationCountReached = this.locationList.length >= this.locationCount;
    }
    // Reset form controls
    requiredFields.forEach(field => {
      const control = this.locationFormGroup.get(field);
      control.reset();
      control.clearValidators();
      control.updateValueAndValidity();
    });

    this.locationFormGroup.get('address2')?.reset();
    if (this.countryName) {
      this.locationFormGroup.get('country')?.setValue(this.countryName, { emitEvent: false });
    }
    this.locationFormGroup.updateValueAndValidity({ emitEvent: false });
    // Refresh filtered list
    this.updateFilteredLocations();
    this.locationFormGroup.get('zipCode')?.disable();
    this.lastValidatedZip['location'] = '';
    this.locationEdit = false;
    this.nextClickList = [...this.locationList];
    this.locationValid = true;
    this.completedSteps[3] = true;
    this.locationNextClick = true;
    this.saveDraftToStorage();
  }

  checkLocationFormValues() {
    const controls = this.locationFormGroup.controls;
    const requiredFields = ['locationName', 'address1', 'city', 'timeZone', 'state', 'zipCode'];
    const otherControls = Object.entries(controls).filter(([key]) => key !== 'country');
    const allEmpty = otherControls.every(([_, control]) =>
      (control.value ?? '').toString().trim() === ''
    );

    if (allEmpty) {
      this.locationValid = true;
      Object.values(controls).forEach(control => control.setErrors(null));
    } else {
      const zipControl = this.locationFormGroup.get('zipCode');
      const hadInvalidZip = !!zipControl?.hasError('invalidZip');
      requiredFields.forEach(field => {
        const control = this.locationFormGroup.get(field);
        if (control) {
          control.setValidators([Validators.required]);
          control.updateValueAndValidity({ emitEvent: false });
          control.markAsTouched();
        }
      });
      if (hadInvalidZip) {
        zipControl?.setErrors({ ...(zipControl.errors || {}), invalidZip: true });
      }
      this.locationValid = this.locationFormGroup.valid;
    }
  }

  addLocationNext() {
    const requiredFields = ['locationName', 'address1', 'city', 'timeZone', 'state', 'zipCode'];
    const formEmpty = this.isLocationFormEmpty();

    // Scenario A: Valid location already saved and form is currently empty
    if (this.locationList.length > 0 && formEmpty) {
      requiredFields.forEach(field => {
        const control = this.locationFormGroup.get(field);
        control?.clearValidators();
        control?.setErrors(null);
        control?.updateValueAndValidity({ emitEvent: false });
      });
      this.locationFormGroup.updateValueAndValidity({ emitEvent: false });
      this.locationValid = true;
      this.completedSteps[3] = true;
      this.locationNextClick = true;
      this.nextClickList = [...this.locationList];
      this.updateFilteredLocations();
      this.saveDraftToStorage();
      this.cdr.detectChanges();
      if (this.stepper) {
        if (this.stepper.steps?.get(3)) {
          this.stepper.steps.get(3)!.completed = true;
        }
        this.stepper.selectedIndex = 4;
      }
      return;
    }

    // Scenario B: User entered new location details in form
    const zipControl = this.locationFormGroup.get('zipCode');
    const hadInvalidZip = !!zipControl?.hasError('invalidZip');
    const zipVal = (zipControl?.value || '').toString().trim();
    requiredFields.forEach(field => {
      const control = this.locationFormGroup.get(field);
      control?.setValidators([Validators.required]);
      control?.updateValueAndValidity({ emitEvent: false });
      control?.markAsTouched();
    });
    if (hadInvalidZip || (zipVal && !this.isValidZipFormat(zipVal, this.countryCode))) {
      zipControl?.setErrors({ ...(zipControl.errors || {}), invalidZip: true });
    }
    this.locationFormGroup.updateValueAndValidity({ emitEvent: false });

    if (this.locationFormGroup.invalid) {
      this.locationValid = false;
      this.locationNextClick = false;
      this.locationError = false;
      return;
    }

    if (zipVal !== this.lastValidatedZip['location']) {
      if (this.zipCodeTimeouts['location']) {
        clearTimeout(this.zipCodeTimeouts['location']);
      }
      this.zipCodeValidation('location', () => {
        if (!this.locationFormGroup.invalid) {
          this.addLocationNext();
        }
      });
      return;
    }

    const newLocation = this.locationFormGroup.getRawValue();
    const existingLoc = this.editIndex !== null ? (this.locationList[this.editIndex] || {}) : {};
    const preservedTimeZone = this.preserveTimeZoneOnSave(existingLoc, newLocation);
    if (!this.assertTimeZoneReadyForSave(preservedTimeZone)) {
      this.locationValid = false;
      this.locationNextClick = false;
      return;
    }
    newLocation.timeZone = preservedTimeZone;
    // Check for duplicates
    const isDuplicate = this.locationList.some((loc, index) =>
      index !== this.editIndex &&
      loc.locationName?.trim().toLowerCase() === newLocation.locationName?.trim().toLowerCase() &&
      loc.address1?.trim().toLowerCase() === newLocation.address1?.trim().toLowerCase() &&
      loc.city?.trim().toLowerCase() === newLocation.city?.trim().toLowerCase() &&
      loc.state?.trim().toLowerCase() === newLocation.state?.trim().toLowerCase() &&
      (loc.country || this.countryName || '')?.toString().trim().toLowerCase() ===
      (newLocation.country || this.countryName || '')?.toString().trim().toLowerCase() &&
      loc.zipCode?.trim().toLowerCase() === newLocation.zipCode?.trim().toLowerCase()
    );

    if (isDuplicate) {
      this.locationError = true;
      this.locationNextClick = false;
      return;
    }

    this.locationError = false;

    if (this.editIndex !== null) {
      // Update mode: preserve existing location ID and metadata if present
      this.locationList[this.editIndex] = {
        ...existingLoc,
        ...newLocation,
        timeZone: preservedTimeZone,
        country: newLocation.country || existingLoc.country || this.countryName || '',
      };
      this.editIndex = null;
      this.originalEditTimeZone = '';
      this.locationEdit = false;
    } else {
      // Add new location
      this.locationList.push({
        ...newLocation,
        timeZone: preservedTimeZone,
        country: newLocation.country || this.countryName || '',
      });
      this.locationEdit = false;
    }

    if (this.locationCount === -1) {
      this.isLocationCountReached = false;
    } else {
      this.isLocationCountReached = this.locationList.length >= this.locationCount;
    }

    // Reset form controls
    requiredFields.forEach(field => {
      const control = this.locationFormGroup.get(field);
      control?.reset();
      control?.clearValidators();
      control?.setErrors(null);
      control?.updateValueAndValidity({ emitEvent: false });
    });
    this.locationFormGroup.get('address2')?.reset();
    if (this.countryName) {
      this.locationFormGroup.get('country')?.setValue(this.countryName, { emitEvent: false });
    }
    this.locationFormGroup.get('zipCode')?.disable();
    this.locationFormGroup.updateValueAndValidity({ emitEvent: false });
    this.lastValidatedZip['location'] = '';

    this.nextClickList = [...this.locationList];
    this.locationValid = true;
    this.completedSteps[3] = true;
    this.locationNextClick = true;

    // Refresh filtered list
    this.updateFilteredLocations();
    this.saveDraftToStorage();
    this.cdr.detectChanges();

    if (this.stepper) {
      if (this.stepper.steps?.get(3)) {
        this.stepper.steps.get(3)!.completed = true;
      }
      this.stepper.selectedIndex = 4;
    }
  }

  editLocation(index: number) {
    const location = this.locationList[index];
    this.isLocationCountReached = false;
    this.populateLocationForm(location, index);
    this.stepper.selectedIndex = 3;
  }

  confirmRemoveLocation(index: number, event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    if (this.isRemovingLocation || this.isLoading) {
      return;
    }
    const location = this.locationList[index];
    if (!location) {
      return;
    }
    if (this.locationsPersisted) {
      this.snackBar.errorSnackbar(
        'This location has already been saved and cannot be removed here. A Delete Location API is not available in onboarding.'
      );
      return;
    }
    const linkedStylists = [...this.stylistList, ...this.nextClickStylistList].filter((stylist) =>
      this.compareLocations(stylist?.location, location)
    );
    if (linkedStylists.length > 0) {
      this.snackBar.errorSnackbar(
        'This location is linked to one or more service providers. Remove those service providers first.'
      );
      return;
    }
    if (!window.confirm('Are you sure you want to remove this location?')) {
      return;
    }
    this.removeLocation(index);
  }

  private removeLocation(index: number): void {
    if (this.isRemovingLocation) {
      return;
    }
    this.isRemovingLocation = true;
    try {
      const removed = this.locationList[index];
      this.locationList = this.locationList.filter((_, i) => i !== index);
      this.nextClickList = this.nextClickList.filter((loc) => !this.compareLocations(loc, removed));
      if (this.editIndex === index) {
        this.resetSpecificFields(this.locationFormGroup, ['locationName', 'address1', 'address2', 'city', 'state', 'timeZone', 'zipCode']);
        if (this.countryName) {
          this.locationFormGroup.get('country')?.setValue(this.countryName, { emitEvent: false });
        }
        this.editIndex = null;
        this.locationEdit = false;
        this.originalEditTimeZone = '';
        this.timeZoneUnresolved = false;
      } else if (this.editIndex !== null && this.editIndex > index) {
        this.editIndex = this.editIndex - 1;
      }
      if (this.stylistFormGroup.get('location')?.value && this.compareLocations(this.stylistFormGroup.get('location')?.value, removed)) {
        this.stylistFormGroup.get('location')?.reset();
      }
      if (this.locationCount === -1) {
        this.isLocationCountReached = false;
      } else {
        this.isLocationCountReached = this.locationList.length >= this.locationCount;
      }
      if (this.locationList.length === 0) {
        this.locationValid = false;
        this.completedSteps[3] = false;
        this.locationNextClick = false;
        this.nextClickList = [];
      } else {
        this.nextClickList = [...this.locationList];
        this.locationValid = true;
      }
      this.updateFilteredLocations();
      this.saveDraftToStorage();
      this.cdr.detectChanges();
    } finally {
      this.isRemovingLocation = false;
    }
  }

  confirmRemoveStylist(index: number, event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    if (this.isRemovingStylist || this.userFeedback.loading) {
      return;
    }
    const stylist = this.stylistList[index];
    if (!stylist) {
      return;
    }
    if (this.stylistsPersisted) {
      this.snackBar.errorSnackbar(
        'This service provider has already been saved and cannot be removed here. A provider-unmap API is not available in onboarding.'
      );
      return;
    }
    if (!window.confirm('Are you sure you want to remove this service provider?')) {
      return;
    }
    this.removeStylist(index);
  }

  private removeStylist(index: number): void {
    if (this.isRemovingStylist) {
      return;
    }
    this.isRemovingStylist = true;
    try {
      const removedEmail = (this.stylistList[index]?.email || '').trim().toLowerCase();
      this.stylistList = this.stylistList.filter((_, i) => i !== index);
      this.nextClickStylistList = this.nextClickStylistList.filter(
        (item) => (item?.email || '').trim().toLowerCase() !== removedEmail
      );
      if (this.editStylistIndex === index) {
        ['location', 'email'].forEach((field) => {
          const control = this.stylistFormGroup.get(field);
          control?.reset();
          control?.clearValidators();
          control?.updateValueAndValidity({ emitEvent: false });
        });
        this.editStylistIndex = null;
        this.stylistEdit = false;
      } else if (this.editStylistIndex !== null && this.editStylistIndex > index) {
        this.editStylistIndex = this.editStylistIndex - 1;
      }
      this.stylistList = this.dedupeByEmail(this.stylistList);
      this.nextClickStylistList = [...this.stylistList];
      if (this.stylistList.length === 0) {
        this.stylistValid = false;
        this.completedSteps[4] = false;
        this.stylistNextClick = false;
      }
      this.totalInput();
      this.saveDraftToStorage();
      this.cdr.detectChanges();
    } finally {
      this.isRemovingStylist = false;
    }
  }

  checkDuplicateEmail(email: string, immediate = false): void {
    const emailControl = this.stylistFormGroup.get('email');
    if (!emailControl) return;

    const normalizedEmail = (email || '').trim().toLowerCase();

    // ✅ Skip current index when editing
    const localExists = this.stylistList.some((stylist, index) =>
      (stylist.email || '').trim().toLowerCase() === normalizedEmail && index !== this.editStylistIndex
    );
    if (localExists) {
      emailControl.setErrors({ ...emailControl.errors, emailExists: true });
      this.stylistNextClick = false;
      this.emailErrorMessage = 'Email already exists in the service provider list.';
      return;
    }

    // Clear emailExists error if previously set
    if (emailControl.errors?.['emailExists']) {
      const newErrors = { ...emailControl.errors };
      delete newErrors['emailExists'];
      emailControl.setErrors(Object.keys(newErrors).length ? newErrors : null);
    }
    this.stylistNextClick = true;

    // Validate email syntax before making API call
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!normalizedEmail || !emailRegex.test(normalizedEmail)) {
      return;
    }

    // Cache lookup: reuse if already fetched in this session
    if (this.emailLookupCache.has(normalizedEmail)) {
      this.applyStylistEmailLookupResponse(this.emailLookupCache.get(normalizedEmail)!, emailControl);
      return;
    }

    // Avoid duplicate requests for unchanged email
    if (this.lastCheckedStylistEmail === normalizedEmail && !emailControl.hasError('emailExists')) {
      return;
    }

    // Cancel pending debounce timer
    if (this.stylistEmailDebounceTimer) {
      clearTimeout(this.stylistEmailDebounceTimer);
    }

    const executeLookup = () => {
      this.lastCheckedStylistEmail = normalizedEmail;
      if (this.emailLookupSubscription) {
        this.emailLookupSubscription.unsubscribe();
      }
      this.emailLookupSubscription = this.userFacadeService.GetUserByEmailOnBoarding(normalizedEmail).subscribe({
        next: (response: UserOnboarding) => {
          if (response) {
            this.emailLookupCache.set(normalizedEmail, response);
            this.applyStylistEmailLookupResponse(response, emailControl);
          }
        },
        error: () => {
          // Keep form operational on lookup failure
        }
      });
    };

    if (immediate) {
      executeLookup();
    } else {
      this.stylistEmailDebounceTimer = setTimeout(executeLookup, 500);
    }
  }

  private applyStylistEmailLookupResponse(response: UserOnboarding, emailControl: AbstractControl): void {
    this.stylistEmailExistingAccount = false;
    // NOTE: Do NOT gate only on `userType === 'ServiceProvider'` — if the API
    // returns userType as "Service Provider"/empty with userTypeId=3, the old
    // gate fell into the `else` below and cleared the block (stylistNextClick=true).
    // Flags may also arrive as 0/1, so normalise them before strict checks.
    const isFirebaseRegistered = (response.isFirebaseRegistered as any) === true || (response.isFirebaseRegistered as any) === 1 || (response.isFirebaseRegistered as any) === 'true';
    const recordStatus = (response.recordStatus as any) === true || (response.recordStatus as any) === 1 || (response.recordStatus as any) === 'true';
    const isServiceProvider =
      Number(response.userTypeId) === 3 ||
      String(response.userType || '').trim().toLowerCase().replace(/\s+/g, '') === 'serviceprovider';
    if (isServiceProvider) {
      let errorMsg = '';
      let errorType = '';

      if (response.isFirebaseRegistered && response.registerStatus && !response.recordStatus) {
        errorMsg = '*Your user account is deactivated. Please contact your Business Owner.';
        errorType = 'emailExists';
      } else if (response.isFirebaseRegistered && response.registerStatus && response.recordStatus) {
        this.stylistEmailExistingAccount = true;
        errorMsg = '';
        errorType = 'emailExists';
      } else if (response.isFirebaseRegistered && !response.registerStatus) {
        errorMsg = '*Your onboarding request is pending for approval...';
        errorType = 'emailExists';
      } else if (
        isServiceProvider &&
        !isFirebaseRegistered &&
        recordStatus === true
      ) {
        this.stylistEmailExistingAccount = true;
        errorMsg = 'You are already a registered user. Please contact support@visitmaker.com';
        errorType = 'emailExists';
      }

      if (errorType) {
        emailControl.setErrors({ ...emailControl.errors, [errorType]: true });
        this.emailErrorMessage = errorMsg;
        this.stylistNextClick = false;
      } else {
        this.stylistNextClick = true;
        this.emailErrorMessage = '';
      }
    } else {
      this.emailErrorMessage = '';
      this.stylistNextClick = true;
    }
  }

  addStylistNext() {
    if (this.userFeedback.loading || this.isPageLoading) return;
    this.isFinalClick = false;

    if (this.locationList.length > 0) {
      this.nextClickList = [...this.locationList];
    }

    const locationControl = this.stylistFormGroup.get('location');
    const emailControl = this.stylistFormGroup.get('email');

    if (this.isStylistFormEmpty()) {
      if (this.stylistList.length > 0) {
        this.nextClickStylistList = [...this.stylistList];
      }
      this.stylistValid = true;
      ['location', 'email'].forEach(field => {
        const control = this.stylistFormGroup.get(field);
        control?.clearValidators();
        control?.updateValueAndValidity({ emitEvent: false });
      });
      if (this.payment !== true) {
        this.submitOnboardingForm();
      }
      this.completedSteps[4] = true;
      this.saveDraftToStorage();
      this.stylistNextClick = true;
      return;
    }

    // Set validators when the user entered provider details
    locationControl?.setValidators([Validators.required]);
    locationControl?.updateValueAndValidity();
    emailControl?.setValidators([
      Validators.required,
      Validators.email,
      NospaceValidator.blockSpace,
    ]);
    emailControl?.updateValueAndValidity();
    const email = emailControl?.value;
    // Format validation
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      emailControl?.setErrors({ ...emailControl.errors, invalidFormat: true });
      this.emailErrorMessage = 'Please enter a valid email address.';
      return;
    }
    if (emailControl?.hasError('emailExists')) {
      return;
    }
    this.checkDuplicateEmail(email, true);

    if (this.stylistFormGroup.invalid || emailControl?.hasError('emailExists')) {
      locationControl?.markAsTouched();
      emailControl?.markAsTouched();
      return;
    }

    const formValue = this.stylistFormGroup.value;
    if (this.stylistFormGroup.valid && formValue?.email) {
      const isDuplicateForm = this.nextClickStylistList.some(
        stylist => stylist.email?.trim().toLowerCase() === formValue.email?.trim().toLowerCase()
      );
      if (!isDuplicateForm) {
        this.nextClickStylistList.push(formValue);
      }
      const newStylists = this.stylistList.filter(
        s => !this.nextClickStylistList.some(
          existing => existing.email?.trim().toLowerCase() === s.email?.trim().toLowerCase()
        )
      );
      this.nextClickStylistList.push(...newStylists);
      this.nextClickStylistList = this.dedupeByEmail(this.nextClickStylistList);
      this.totalInput();
    }

    if (this.payment !== true) {
      this.submitOnboardingForm();
    }
    this.completedSteps[4] = true;
    this.saveDraftToStorage();
    this.stylistNextClick = true;
  }

  private dedupeByEmail(list: any[]): any[] {
    const seen = new Set<string>();
    return list.filter(item => {
      const k = item.email?.trim().toLowerCase();
      if (!k || seen.has(k)) return false;
      seen.add(k);
      return true;
    });
  }

  addStylist(): void {
    if (this.userFeedback.loading || this.isPageLoading) return;
    const locationControl = this.stylistFormGroup.get('location');
    const emailControl = this.stylistFormGroup.get('email');
    locationControl?.setValidators([Validators.required]);
    locationControl?.updateValueAndValidity();
    emailControl?.setValidators([Validators.required,
    Validators.email,
    NospaceValidator.blockSpace,]);
    emailControl?.updateValueAndValidity();
    const email = emailControl?.value;
    // ✅ Only run format validation if email has value
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      emailControl?.setErrors({ ...emailControl.errors, invalidFormat: true });
      this.emailErrorMessage = 'Please enter a valid email address.';
      return;
    }
    this.checkDuplicateEmail(email, true);
    setTimeout(() => {
      if (this.stylistFormGroup.invalid && this.stylistList.length !== 0) {
        this.stylistValid = true;
      } else {
        this.stylistValid = false;
      }
      if (this.stylistFormGroup.invalid || emailControl?.hasError('emailExists')) {
        // If the form is invalid OR email has duplicate error, block submission
        return;
      }

      if (this.stylistFormGroup.valid) {
        if (this.editStylistIndex !== null) {
          this.stylistList[this.editStylistIndex] = this.stylistFormGroup.value;
          this.editStylistIndex = null;
        } else {
          this.stylistList.push(this.stylistFormGroup.value);
        }
        this.nextClickStylistList =
          this.dedupeByEmail([...this.nextClickStylistList, ...this.stylistList]);
        this.stylistList = this.dedupeByEmail(this.stylistList);
        this.nextClickStylistList = [...this.stylistList];
        this.totalInput();
        this.stylistValid = true;
        this.completedSteps[4] = true;
        this.saveDraftToStorage();
        // Clear form controls and validators
        ['location', 'email'].forEach(field => {
          const control = this.stylistFormGroup.get(field);
          control?.reset();
          control?.clearValidators();
          control?.updateValueAndValidity();
        });
      }
    }, 300);
    this.stylistEdit = false;
    this.NextButtonDisable = false;
    this.stylistNextClick = false;
  }

  editStylist(index: number) {
    const stylist = this.stylistList[index];
    this.stylistFormGroup.patchValue(stylist);
    this.editStylistIndex = index;
    this.stylistEdit = true;
    this.NextButtonDisable = true;
  }

  private isValidZipFormat(zipCode: string, countryCode: string): boolean {
    if (!zipCode) return false;
    const clean = zipCode.trim();
    const cCode = (countryCode || '').toUpperCase();
    switch (cCode) {
      case 'IN':
        return /^\d{6}$/.test(clean);
      case 'US':
        return /^\d{5}(-\d{4})?$/.test(clean);
      case 'CA':
        return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(clean);
      case 'GB':
      case 'UK':
        return /^[A-Za-z]{1,2}\d[A-Za-z\d]?\s*\d[A-Za-z]{2}$/.test(clean);
      case 'AU':
        return /^\d{4}$/.test(clean);
      default:
        return /^[A-Za-z0-9\s-]{3,10}$/.test(clean);
    }
  }

  onZipCodeInput(context: 'business' | 'location'): void {
    if (context === 'location') {
      this.isLocationCountReached = true;
    }
    const group = context === 'business' ? this.businessFormGroup : this.locationFormGroup;
    const zipControl = group.get('zipCode');
    const zipCode = zipControl?.value?.trim() || '';

    // Cancel in-flight request for this context if input changes
    if (this.zipCodeSubscriptions[context]) {
      this.zipCodeSubscriptions[context]?.unsubscribe();
      delete this.zipCodeSubscriptions[context];
    }

    // Reset debounce timer
    if (this.zipCodeTimeouts[context]) {
      clearTimeout(this.zipCodeTimeouts[context]);
    }

    if (!zipCode) {
      this.lastValidatedZip[context] = '';
      this.isLoading = false;
      return;
    }

    // Do not repeatedly validate the same unchanged value
    if (zipCode === this.lastValidatedZip[context]) {
      return;
    }

    // Validate format immediately and surface inline error if invalid
    if (!this.isValidZipFormat(zipCode, this.countryCode)) {
      this.lastValidatedZip[context] = '';
      this.isLoading = false;
      zipControl?.setErrors({ ...(zipControl.errors || {}), invalidZip: true });
      zipControl?.markAsTouched();
      return;
    }

    // Clear format-level invalidZip while waiting for backend validation
    if (zipControl?.errors?.['invalidZip']) {
      const updatedErrors = { ...zipControl.errors };
      delete updatedErrors['invalidZip'];
      zipControl.setErrors(Object.keys(updatedErrors).length ? updatedErrors : null);
    }

    this.zipCodeTimeouts[context] = setTimeout(() => {
      this.zipCodeValidation(context);
    }, 500);
  }

  zipCodeValidation(context: 'business' | 'location', onValid?: () => void): void {
    let zipControl: AbstractControl | null;
    let stateControl: AbstractControl | null;
    if (context === 'location') {
      this.locationNextClick = true;
    }
    this.isLoading = true;
    if (context === 'business') {
      zipControl = this.businessFormGroup.get('zipCode');
      stateControl = this.businessFormGroup.get('state');
    } else {
      zipControl = this.locationFormGroup.get('zipCode');
      stateControl = this.locationFormGroup.get('state');
      if (this.locationList.length !== 0) {
        this.checkLocationFormValues();
      }
    }

    const zipCode = zipControl?.value?.trim();
    const state = stateControl?.value;
    if (!zipCode || !this.isValidZipFormat(zipCode, this.countryCode)) {
      this.isLoading = false;
      if (zipCode) {
        zipControl?.setErrors({ ...(zipControl.errors || {}), invalidZip: true });
        zipControl?.markAsTouched();
      }
      return;
    }

    // Do not repeatedly validate the same unchanged value if already valid
    if (zipCode === this.lastValidatedZip[context] && !zipControl?.hasError('invalidZip')) {
      this.isLoading = false;
      onValid?.();
      return;
    }
    this.lastValidatedZip[context] = zipCode;

    const data = { pinCode: zipCode, state, countryCode: this.countryCode };

    if (this.zipCodeSubscriptions[context]) {
      this.zipCodeSubscriptions[context]?.unsubscribe();
    }

    this.zipCodeSubscriptions[context] = this.subscriptionFacadeService.zipCodeValidation(data).subscribe({
      next: (response: any) => {
        const resText = (response ?? '').toString().trim().toLowerCase();
        if (resText === 'invalid zipcode') {
          this.nextClick = true;
          this.isLocationCountReached = true;
          this.isLoading = false;
          zipControl?.setErrors({
            ...zipControl.errors,
            invalidZip: true,
          });
          zipControl?.markAsTouched();
        } else {
          this.isLocationCountReached = false;
          this.nextClick = false;
          this.isLoading = false;
          if (zipControl?.errors?.['invalidZip']) {
            const updatedErrors = { ...zipControl.errors };
            delete updatedErrors['invalidZip'];
            zipControl.setErrors(Object.keys(updatedErrors).length ? updatedErrors : null);
          }
          if (context === 'location') {
            this.checkLocationFormValues();
          }
          onValid?.();
        }
      },
      error: () => {
        zipControl?.setErrors({ ...(zipControl?.errors || {}), invalidZip: true });
        zipControl?.markAsTouched();
        this.isLoading = false;
        this.userFeedback.stopLoading();
      },
    });
  }

  createMultipleLocation() {
    const numericClientId = parseInt(String(this.clientId ?? ''), 10);
    if (!Number.isFinite(numericClientId) || numericClientId <= 0) {
      this.persistFormStateAfterSubmissionError(
        'Missing or invalid Client ID. Please verify your business details and try again.'
      );
      return;
    }
    this.clientId = numericClientId;
    if (this.locationsPersisted && this.clientId) {
      this.continueAfterLocationsPersisted();
      return;
    }
    const sourceList = this.nextClickList.length !== 0 ? this.nextClickList : this.locationList;
    if (!sourceList || sourceList.length === 0) {
      this.persistFormStateAfterSubmissionError(
        'Please add at least one location before continuing.'
      );
      return;
    }
    const missingTimeZone = sourceList.some((list) => !this.normalizeTimeZoneValue(list.timeZone));
    if (missingTimeZone) {
      this.persistFormStateAfterSubmissionError(
        'One or more locations are missing a Time Zone. Please edit the location and select a valid Time Zone.'
      );
      return;
    }
    const data = sourceList.map(list => ({
      id: 0,
      clientId: numericClientId,
      images: "",
      locationName: (list.locationName || '').toString().trim(),
      address1: (list.address1 || '').toString().trim(),
      address2: (list.address2 || '').toString().trim(),
      state: (list.state || '').toString().trim(),
      country: (list.country || this.countryName || '').toString().trim(),
      city: (list.city || '').toString().trim(),
      pincode: (list.zipCode || '').toString().trim(),
      timeZone: this.normalizeTimeZoneValue(list.timeZone),
      recordStatus: true,
      createdBy: numericClientId
    }));
    this.subscriptionFacadeService.createMultipleLocation(data).subscribe({
      next: (response: any) => {
        const resText = this.normalizeTextResponse(response).toLowerCase();
        if (resText === 'invalid zipcode') {
          this.isProcessing = false;
          this.isFinalClick = false;
          this.isLoading = false;
          this.userFeedback.stopLoading();
          if (this.stepper) {
            this.stepper.selectedIndex = 3;
          }
          this.notifyUi();
          this.subscriptionError('Invalid ZIP Code');
          return;
        }
        this.locationsPersisted = true;
        this.getLocationsList();
      },
      error: (error) => {
        this.persistFormStateAfterSubmissionError(
          'Failed to create locations. Please try again.',
          error
        );
      },
    });
  }

  getLocationsList(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const clientId = this.clientId;
      this.locationFacadeService.getLocationList(clientId).subscribe({
        next: (response: any) => {
          this.locations = response;
          if (this.locations && this.locations.length > 0) {
            this.createMultipleStylist();
          } else {
            this.afterStylistProvisionComplete();
          }
          resolve();
        },
        error: (error) => {
          this.persistFormStateAfterSubmissionError(
            'Could not load locations after save. Please try Pay again.',
            error
          );
          resolve();
        }
      })
    });
  }

  createMultipleStylist() {
    if (this.stylistsPersisted && this.payment === true) {
      this.afterStylistProvisionComplete();
      return;
    }

    let stylistPayloadList = [];
    if (this.nextClickStylistList.length !== 0) {
      stylistPayloadList = this.nextClickStylistList.map(stylist => ({
        locationId: this.resolveLocationIdForStylist(stylist?.location),
        stylistEmail: stylist.email,
        clientId: parseInt(this.clientId, 10),
      }));
    } else {
      stylistPayloadList = this.stylistList.map(stylist => ({
        locationId: this.resolveLocationIdForStylist(stylist?.location),
        stylistEmail: stylist.email,
        clientId: parseInt(this.clientId, 10),
      }));
    }

    stylistPayloadList = stylistPayloadList.filter(
      (row) => row.stylistEmail && String(row.stylistEmail).trim().length > 0
    );

    if (stylistPayloadList.length === 0) {
      this.afterStylistProvisionComplete();
      return;
    }

    this.subscriptionFacadeService.createMultipleStylist(stylistPayloadList).subscribe({
      next: (response: any) => {
        this.afterStylistProvisionComplete(response);
      },
      error: (error) => {
        const msg = this.resolvePaymentFailureMessage(
          'Failed to map service provider. Please try again.',
          error
        );
        if (this.payment === true) {
          this.handlePaymentFailure(msg, error);
        } else {
          this.persistFormStateAfterSubmissionError(msg, error);
        }
      },
    });
  }

  promoCodeValidation() {
    this.userFeedback.startLoading();
    try {
      const data = {
        planId: this.planId,
        promoCode: this.promoCodeValue,
        subFrequencyId: this.subFreeId,
        clientCountryId: this.countryId
      };
      this.subscriptionFacadeService.promoCodeValidation(data).subscribe({
        next: (response: any) => {
          if (this.promoCodeValue !== '' && response.status === 'Success') {
            this.promoPriceView = true;
          } else {
            this.promoPriceView = false;
          }
          if (response.status === 'Invalid KeyCode') {
            this.userFeedback.stopLoading();
            this.promoValidation = response.status;
            this.pricingId = (!this.promoCodeValue && this.keyCode) ? this.promoCodeRemove : this.exitingPricingId;
            if (this.subFreeId === 1) {
              this.amount = (!this.promoCodeValue && this.keyCode) ? this.originalPrice : this.existingAmount;
            } else if (this.subFreeId === 2) {
              this.amount = (!this.promoCodeValue && this.keyCode) ? this.originalPrice : this.existingAmount;
            } else if (this.subFreeId === 3) {
              this.amount = (!this.promoCodeValue && this.keyCode) ? this.originalPrice : this.existingAmount;
            }
            this.initializeTotalPrice();
          } else {
            this.userFeedback.stopLoading();
            this.promoValidation = "";
            if (response != 0) {
              this.promoPriceView = true;
              this.pricingId = response.priceId;
              if (this.subFreeId === 1) {
                this.amount = response.offerPrice;
              } else if (this.subFreeId === 2) {
                this.amount = Math.round((response.offerPrice / 3) * 100) / 100;
              } else if (this.subFreeId === 3) {
                this.amount = Math.round((response.offerPrice / 12) * 100) / 100;
              }
              this.initializeTotalPrice();
            } else {
              this.promoPriceView = false;
            }
          }
        },
        error: (error) => {
          this.userFeedback.stopLoading();
          this.snackBar.errorSnackbar(
            this.resolvePaymentFailureMessage(
              'Something went wrong, please try again',
              error
            )
          );
        }
      });
    } catch (error) {
      this.userFeedback.stopLoading();
      this.snackBar.errorSnackbar(
        this.resolvePaymentFailureMessage(
          'Something went wrong, please try again',
          error
        )
      );
    }
  }

  promoCode(value: string): void {
    this.promoCodeValue = value;
    this.promoCodeValidation();
  }

  resetSpecificFields(formGroup: FormGroup, fieldsToReset: string[]) {
    fieldsToReset.forEach((fieldName) => {
      const control = formGroup.get(fieldName);
      if (control) {
        control.reset(); // clear the value
        control.markAsPristine(); // make it look untouched
        control.markAsUntouched();
        control.updateValueAndValidity({ onlySelf: true, emitEvent: false }); // prevent triggering validation
      }
    });
  }

  resetForm() {
    this.locationList = [];
    this.stylistList = [];
    this.nextClickStylistList = [];
    if (this.phoneInputComponent) {
      this.phoneInputComponent.reset();
    }
    this.resetSpecificFields(this.personalFormGroup, ['firstName', 'lastName', 'mobNumber', 'password', 'confirmPassword']);
    this.personalFormGroup.reset({}, { emitEvent: false });
    this.resetSpecificFields(this.businessFormGroup, ['busiName', 'address1', 'address2', 'city', 'state', 'zipCode']);
    this.resetSpecificFields(this.locationFormGroup, ['locationName', 'address1', 'address2', 'city', 'state', 'timeZone', 'zipCode']);
    this.resetSpecificFields(this.stylistFormGroup, ['location', 'email']);
    this.resetSpecificFields(this.stripeFormGroup, ['promoCode', 'cardNumber']);
  }

  /* Whether a step's data is complete, judged the same way the flow
     itself judges it: steps 0-2 by their form, steps 3-4 by their
     saved list (their forms are intentionally emptied after Add) or
     a currently valid form. Used only for navigation bookkeeping —
     no validation rule is added or removed. */
  isStepDataValid(index: number): boolean {
    switch (index) {
      case 0:
        return this.completedSteps[0] || (!!this.emailFormGroup?.valid && !this.emailError);
      case 1:
        if (this.completedSteps[1]) return true;
        if (this.hidePasswords || this.customer) {
          const fn = this.personalFormGroup?.get('firstName')?.valid;
          const ln = this.personalFormGroup?.get('lastName')?.valid;
          const mn = this.personalFormGroup?.get('mobNumber')?.valid;
          return !!(fn && ln && mn);
        }
        return !!this.personalFormGroup?.valid;
      case 2:
        return this.completedSteps[2] || !!this.businessFormGroup?.valid;
      case 3:
        return this.completedSteps[3] || this.locationList.length > 0 || this.nextClickList.length > 0
          || this.locationValid === true || !!this.locationFormGroup?.valid;
      case 4:
        return this.completedSteps[4] || this.stylistList.length > 0 || this.nextClickStylistList.length > 0
          || this.stylistValid === true || !!this.stylistFormGroup?.valid;
      default:
        return true;
    }
  }

  /* Clicking a completed (or the furthest reached) step label reopens
     it with its previously entered values — the FormGroups/lists are
     never reset on navigation, so reopening is prefilled by
     construction. Opening a step never advances, submits, or calls
     any API. Incomplete/future steps are left to the native linear
     stepper (mandatory steps cannot be bypassed). */
  goToCompletedStep(index: number, event?: Event): void {
    if (!this.completedSteps[index] && index > this.furthestStepIndex) {
      if (event) { event.stopPropagation(); }
      return;
    }
    if (this.stepper && index !== this.currentStepIndex) {
      this.stepper.selectedIndex = index;
    }
  }

  /* Return to the furthest step reached, without losing progress. */
  returnToLatestStep(): void {
    if (this.stepper) {
      this.stepper.selectedIndex = this.furthestStepIndex;
    }
  }

  onSelectionChange(event: StepperSelectionEvent): void {
    if (this.isFinalClick && event.selectedIndex < event.previouslySelectedIndex) {
      Promise.resolve().then(() => {
        this.stepper.selectedIndex = event.previouslySelectedIndex;
      });
      return;
    }

    // Prefill location form only when reopening a completed location step (not on first forward entry from business).
    if (
      event.selectedIndex === 3 &&
      event.selectedIndex < event.previouslySelectedIndex &&
      this.locationList.length > 0 &&
      this.isLocationFormEmpty()
    ) {
      const idx = (this.editIndex !== null && this.editIndex < this.locationList.length) ? this.editIndex : 0;
      this.populateLocationForm(this.locationList[idx], idx);
    }

    // Step 5 entering: ensure location dropdown is populated
    if (event.selectedIndex === 4) {
      this.updateFilteredLocations();
      if (this.locationList.length > 0 && !this.stylistFormGroup.get('location')?.value) {
        this.stylistFormGroup.get('location')?.setValue(this.locationList[0]);
      }
    }

    if (event.selectedIndex === 1) {
      this.syncPhoneCountryFromPlan();
    }

    if (event.selectedIndex === this.getPaymentStepIndex()) {
      this.totalInput();
    }

    if (event.selectedIndex > event.previouslySelectedIndex) {
      // Forward movement: check earlier steps. Completed steps remain valid and are not reset.
      for (let i = 0; i < event.selectedIndex; i++) {
        if (!this.isStepDataValid(i)) {
          const firstInvalid = i;
          Promise.resolve().then(() => {
            this.stepper.selectedIndex = firstInvalid;
          });
          return;
        }
      }
      // Record completion for passed steps
      for (let i = 0; i < event.selectedIndex; i++) {
        if (this.isStepDataValid(i)) {
          this.completedSteps[i] = true;
        }
      }
    } else if (event.selectedIndex < event.previouslySelectedIndex) {
      // Backward movement: ensure previously valid step remains completed
      const prevIdx = event.previouslySelectedIndex;
      if (this.isStepDataValid(prevIdx)) {
        this.completedSteps[prevIdx] = true;
      }
    }
    this.currentStepIndex = event.selectedIndex;
    this.furthestStepIndex = Math.max(this.furthestStepIndex, event.selectedIndex);
    this.saveDraftToStorage();
  }

  private initializePlanCountryFromQuery(): void {
    this.code = this.activatedRouter.snapshot.queryParamMap.get('countryCode');
    this.countryCode = this.normalizePlanCountryCode(this.code);
    this.syncPhoneCountryFromPlan();
  }

  private normalizePlanCountryCode(raw: string | null): string {
    const value = (raw || '').trim().toUpperCase();
    if (!value) {
      return 'US';
    }
    if (value === 'USD') {
      return 'US';
    }
    if (value === 'INR') {
      return 'IN';
    }
    if (this.currencyToCountryMap[value]) {
      return this.currencyToCountryMap[value];
    }
    return value;
  }

  private resolvePlanCountryIso2(): string {
    const fromCountryCode = (this.countryCode || '').trim().toUpperCase();
    if (fromCountryCode === 'US') {
      return 'us';
    }
    if (fromCountryCode === 'IN') {
      return 'in';
    }
    if (fromCountryCode.length === 2) {
      return fromCountryCode.toLowerCase();
    }
    const fromQuery = this.normalizePlanCountryCode(this.code);
    if (fromQuery.length === 2) {
      return fromQuery.toLowerCase();
    }
    return 'us';
  }

  private syncPhoneCountryFromPlan(): void {
    const iso2 = this.resolvePlanCountryIso2();
    this.preferredCountryList = [iso2];
    this.applyPhoneSelectedCountry(iso2);
  }

  private applyPhoneSelectedCountry(iso2: string): void {
    const normalized = (iso2 || 'us').toLowerCase();
    const dialByIso: Record<string, string> = {
      us: '1',
      in: '91',
    };
    const nameByIso: Record<string, string> = {
      us: 'United States',
      in: 'India',
    };
    this.selectedCountry = {
      name: nameByIso[normalized] || normalized.toUpperCase(),
      iso2: normalized,
      dialCode: dialByIso[normalized] || '1',
      priority: 0,
      flagClass: normalized.toUpperCase(),
    };
    if (this.phoneInputComponent) {
      this.phoneInputComponent.selectedCountry = this.selectedCountry;
    }
  }

  private persistFormStateAfterSubmissionError(
    fallback = 'Something went wrong, Please try again.',
    err?: unknown
  ): void {
    this.reportOnboardingApiError(fallback, err);
  }

  private clearSubmissionLoadingState(): void {
    this.isFinalClick = false;
    this.isProcessing = false;
    this.paymentInProgress = false;
    this.userFeedback.stopLoading();
    this.notifyUi();
  }

  /** Stops page + submit spinners after bootstrap or unrecoverable API failure. */
  private stopAllOnboardingLoaders(): void {
    this.isPageLoading = false;
    this.isProcessing = false;
    this.isFinalClick = false;
    this.paymentInProgress = false;
    this.userFeedback.stopLoading();
    this.notifyParentOnboardingReady();
    this.notifyUi();
  }

  private notifyParentOnboardingReady(): void {
    try {
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({ type: 'vm-onboarding-ready' }, '*');
      }
    } catch (e) { }
  }

  private reportOnboardingApiError(fallback: string, err?: unknown): void {
    this.stopAllOnboardingLoaders();
    if (!navigator.onLine) {
      this.subscriptionError(
        'You are offline. Please check your internet connection.'
      );
      return;
    }
    this.subscriptionError(this.resolvePaymentFailureMessage(fallback, err));
  }

  shouldShowStripeMount(): boolean {
    if (this.payment !== true || this.countryId != 233) {
      return false;
    }
    return this.paymentInProgress || this.currentStepIndex === this.getPaymentStepIndex();
  }

  private getStripeCardComponent(): StripeCardComponent | undefined {
    return this.stripeCardHost || this.card;
  }

  private completeOnboardingSuccess(): void {
    this.paymentInProgress = false;
    this.paymentRecoveryMode = false;
    this.paySuccess = true;
    this.subscriptionChargeConfirmed = false;
    this.clearDraftStorage();
    this.clearPaymentFailure();
    this.clearSubmissionLoadingState();
    this.notifyUi();
    try {
      this.cdr.detectChanges();
    } catch {
      // no-op
    }
  }

  private resolvePaymentFailureMessage(fallback: string, raw?: unknown): string {
    if (raw == null) {
      return fallback;
    }
    if (typeof raw === 'string' && raw.trim()) {
      return raw.trim();
    }
    if (raw instanceof HttpErrorResponse) {
      const body = raw.error;
      if (typeof body === 'string' && body.trim()) {
        return body.trim();
      }
      if (body && typeof body === 'object') {
        const msg =
          (body as { message?: string }).message ||
          (body as { error?: string }).error ||
          (body as { title?: string }).title;
        if (msg && String(msg).trim()) {
          return String(msg).trim();
        }
      }
      if (raw.status >= 500) {
        return `Server error (${raw.status}). Please try again in a moment.`;
      }
      if (raw.status >= 400) {
        return `Request failed (${raw.status}). Please try again.`;
      }
      if (raw.message) {
        return raw.message;
      }
    }
    if (typeof raw === 'object') {
      const stripeLike = raw as { message?: string; code?: string };
      if (stripeLike.message) {
        return stripeLike.code
          ? `${stripeLike.message} (${stripeLike.code})`
          : stripeLike.message;
      }
    }
    const text = this.normalizeTextResponse(raw);
    return text || fallback;
  }

  private isLikelyPaymentErrorText(value: string): boolean {
    if (!value) {
      return false;
    }
    const lower = value.toLowerCase();
    if (value.startsWith('pm_') || value.startsWith('sub_')) {
      return false;
    }
    return (
      lower.includes('declin') ||
      lower.includes('insufficient') ||
      lower.includes('expired') ||
      lower.includes('incorrect') ||
      lower.includes('invalid') ||
      lower.includes('fail') ||
      lower.includes('error')
    );
  }

  private notifyUi(): void {
    try {
      this.cdr.markForCheck();
    } catch {
      // no-op
    }
  }

  private normalizeTextResponse(response: unknown): string {
    if (response == null) {
      return '';
    }
    return String(response).trim().replace(/^["']+|["']+$/g, '').trim();
  }

  private isSubscriptionSuccess(response: unknown): boolean {
    const text = this.normalizeTextResponse(response).toLowerCase();
    // CreateSubscription may return empty/"Success" or a license/subscription id
    // after PurchaseAdditionalLicense; only treat clear payment errors as failure.
    if (!text || text === 'success' || text === 'ok' || text === 'true') {
      return true;
    }
    if (
      text.startsWith('sub_') ||
      text.startsWith('in_') ||
      text.startsWith('si_') ||
      text.startsWith('pm_') ||
      /^\d+$/.test(text)
    ) {
      return true;
    }
    if (text.includes('success') && !this.isLikelyPaymentErrorText(text)) {
      return true;
    }
    return false;
  }

  /** Runs after CreateMultipleStylist (or skip) — always continues to payment or trial. */
  private afterStylistProvisionComplete(_apiResponse?: unknown): void {
    if (this.stylistPostPaymentHandled) {
      return;
    }
    this.stylistPostPaymentHandled = true;
    this.stylistsPersisted = true;
    this.onboardingRegistrationComplete = true;
    this.paymentInProgress = this.payment === true;
    this.ngZone.run(() => {
      try {
        if (this.isPaidPlan()) {
          this.proceedToPayment();
        } else if (this.payment === false) {
          this.subscribeTrialPeriod();
        } else {
          this.handlePaymentFailure(
            'Plan could not be loaded. Refresh the page and try Pay again.'
          );
        }
      } catch {
        this.handlePaymentFailure('Something went wrong, Please try again.');
      }
    });
  }

  private isPaidPlan(): boolean {
    return this.payment === true || (this.payment !== false && !this.freePlan && !this.trialPeriod);
  }

  private proceedToPayment(): void {
    if (!this.isPaidPlan()) {
      this.subscribeTrialPeriod();
      return;
    }
    this.paymentInProgress = true;
    if (!this.ensureFormSubmissionSnapshot()) {
      this.handlePaymentFailure('Please complete all steps before paying.');
      return;
    }
    if (this.stepper) {
      this.stepper.selectedIndex = this.getPaymentStepIndex();
    }
    this.notifyUi();
    if (this.countryId == 233) {
      setTimeout(() => this.beginUsStripePayment(0), 0);
    } else {
      this.createSubscription();
    }
  }

  private beginUsStripePayment(attempt: number): void {
    if (this.stepper) {
      this.stepper.selectedIndex = this.getPaymentStepIndex();
    }
    this.currentStepIndex = this.getPaymentStepIndex();
    this.paymentInProgress = true;
    this.cdr.detectChanges();
    const stripeCard = this.getStripeCardComponent();
    if (!stripeCard?.element) {
      if (attempt < 80) {
        setTimeout(() => this.beginUsStripePayment(attempt + 1), 150);
        return;
      }
      this.handlePaymentFailure(
        'Card field is not ready. Stay on the Payment step and click Pay again.'
      );
      return;
    }
    this.card = stripeCard;
    const cardOk = this.cardComplete || this.cardValidatedAtPay;
    if (!cardOk) {
      this.cardErrors = 'Please enter card details';
      this.handlePaymentFailure('Please enter card details');
      return;
    }
    this.card = stripeCard;
    this.createToken();
  }

  private resolveLocationIdForStylist(stylistLocation: any): number {
    if (!this.locations?.length || !stylistLocation) {
      return 0;
    }
    const match = this.locations.find((loc) =>
      this.compareLocations(loc, stylistLocation)
    );
    if (match?.id) {
      return Number(match.id);
    }
    const name = (stylistLocation.locationName || stylistLocation).toString().trim().toLowerCase();
    const byName = this.locations.find(
      (loc) => (loc.locationName || '').trim().toLowerCase() === name
    );
    return byName?.id ? Number(byName.id) : 0;
  }

  /** Keeps payment APIs callable after async onboarding (form groups remain source of truth). */
  private ensureFormSubmissionSnapshot(): boolean {
    if (
      this.formSubmissionInfo?.email?.emailCtrl &&
      this.formSubmissionInfo?.personal?.firstName
    ) {
      return true;
    }
    const emailOk = !!this.emailFormGroup?.get('emailCtrl')?.value;
    const personalOk =
      !!this.personalFormGroup?.get('firstName')?.value &&
      !!this.personalFormGroup?.get('lastName')?.value;
    const businessOk = !!this.businessFormGroup?.get('busiName')?.value;
    if (!emailOk || !personalOk || !businessOk) {
      return false;
    }
    this.formSubmissionInfo = {
      email: this.emailFormGroup.value,
      personal: this.personalFormGroup.value,
      business: this.businessFormGroup.value,
      location: this.locationFormGroup.value,
      stylist: this.stylistFormGroup.value,
    };
    return true;
  }

  private continueProvisioningAfterClient(): void {
    if (this.locationsPersisted) {
      this.continueAfterLocationsPersisted();
      return;
    }
    this.createMultipleLocation();
  }

  private continueAfterLocationsPersisted(): void {
    if (this.stylistsPersisted) {
      this.proceedToPayment();
      return;
    }
    this.getLocationsList();
  }

  private sanitizePersonalDraft(personal: Record<string, unknown> | null | undefined): Record<string, unknown> {
    const copy = { ...(personal || {}) };
    delete copy['password'];
    delete copy['confirmPassword'];
    return copy;
  }

  saveDraftToStorage(): void {
    // Intentionally in-memory only: do not persist onboarding drafts across reload.
  }

  loadDraftFromStorage(): void {
    try {
      let raw = '';
      try { raw = sessionStorage.getItem(this.DRAFT_STORAGE_KEY) || ''; } catch (e) { }
      if (!raw) return;

      const draft = JSON.parse(raw);
      if (!draft || typeof draft !== 'object') return;

      this.isRestoringDraft = true;

      if (draft.emailForm) {
        this.emailFormGroup?.patchValue(draft.emailForm, { emitEvent: false });
      }
      if (draft.customer !== undefined) this.customer = draft.customer;
      if (draft.hidePasswords !== undefined) this.hidePasswords = draft.hidePasswords;

      if (draft.personalForm) {
        this.personalFormGroup?.patchValue(draft.personalForm, { emitEvent: false });
      }
      if (this.hidePasswords || this.customer) {
        this.removePasswordValidations();
      }

      if (draft.businessForm) {
        this.businessFormGroup?.patchValue(draft.businessForm, { emitEvent: false });
        if (draft.businessForm.state) {
          this.businessFormGroup?.get('zipCode')?.enable();
        }
      }

      if (Array.isArray(draft.locationList) && draft.locationList.length > 0) {
        this.locationList = [...draft.locationList];
        this.nextClickList = Array.isArray(draft.nextClickList) && draft.nextClickList.length > 0
          ? [...draft.nextClickList]
          : [...draft.locationList];
        this.locationValid = true;
      }

      if (draft.locationForm) {
        this.populateLocationForm(draft.locationForm, this.editIndex);
      } else if (this.locationList.length > 0) {
        this.populateLocationForm(this.locationList[0], 0);
      }

      if (Array.isArray(draft.stylistList) && draft.stylistList.length > 0) {
        this.stylistList = [...draft.stylistList];
        this.nextClickStylistList = Array.isArray(draft.nextClickStylistList) && draft.nextClickStylistList.length > 0
          ? [...draft.nextClickStylistList]
          : [...draft.stylistList];
        this.stylistValid = true;
      }

      this.updateFilteredLocations();

      if (draft.stylistForm) {
        this.stylistFormGroup?.patchValue(draft.stylistForm, { emitEvent: false });
        if (draft.stylistForm.location && this.locationList.length > 0) {
          const match = this.locationList.find(l => this.compareLocations(l, draft.stylistForm.location));
          if (match) {
            this.stylistFormGroup?.get('location')?.setValue(match);
          }
        }
      } else if (this.locationList.length > 0) {
        this.stylistFormGroup?.get('location')?.setValue(this.locationList[0]);
      }

      if (draft.clientId) this.clientId = draft.clientId;
      if (draft.userId) this.userId = draft.userId;
      if (draft.country) this.country = draft.country;
      if (draft.locationValid !== undefined) this.locationValid = draft.locationValid;
      if (draft.stylistValid !== undefined) this.stylistValid = draft.stylistValid;

      if (Array.isArray(draft.completedSteps)) {
        this.completedSteps = [...draft.completedSteps];
      }
      if (typeof draft.furthestStepIndex === 'number') {
        this.furthestStepIndex = draft.furthestStepIndex;
      }

      const targetStep = typeof draft.currentStepIndex === 'number' ? draft.currentStepIndex : (draft.furthestStepIndex || 0);
      this.currentStepIndex = targetStep;

      if (targetStep > 0) {
        setTimeout(() => {
          if (this.stepper) {
            this.stepper.selectedIndex = targetStep;
          }
        }, 100);
      }
    } catch (err) {
      console.warn('Failed to load onboarding draft', err);
    } finally {
      this.isRestoringDraft = false;
      this.syncPhoneCountryFromPlan();
    }
  }

  clearDraftStorage(): void {
    try {
      sessionStorage.removeItem(this.DRAFT_STORAGE_KEY);
      try { localStorage.removeItem(this.DRAFT_STORAGE_KEY); } catch (e) { }
    } catch (e) { }
  }

  private restoreStepperStep(): void {
    if (this.currentStepIndex > 0) {
      setTimeout(() => {
        if (this.stepper) {
          this.stepper.selectedIndex = this.currentStepIndex;
        }
      }, 50);
    }
  }
}
